/**
 * Created by karthikeyan.k on 15-11-2017.
 */
export class TutorialDesktopPosition {
  public static get QUICKKEYSHEADERPOSITION(): any {
    return {
      ar: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 469,
        headerTop: 40,

        wordwrap: 'normal',
        lineHeight: 9,
        letterspacing: 0,
        textResize: 9,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 18,
        left3Height: 18,
        left3Top: 191,
        left3Left: 581,

        left4Width: 18,
        left4Height: 18,
        left4Top: 220,
        left4Left: 581,

        left5Width: 18,
        left5Height: 18,
        left5Top: 250,
        left5Left: 582,

        left6Width: 18,
        left6Height: 18,
        left6Top: 279,
        left6Left: 581,

        left7Width: 18,
        left7Height: 18,
        left7Top: 307,
        left7Left: 581,

        left8Width: 18,
        left8Height: 18,
        left8Top: 339,
        left8Left: 581,

        left9Width: 18,
        left9Height: 18,
        left9Top: 369,
        left9Left: 583,

        left10Width: 18,
        left10Height: 18,
        left10Top: 396,
        left10Left: 582,

        left11Width: 18,
        left11Height: 18,
        left11Top: 426,
        left11Left: 582,

        left12Width: 18,
        left12Height: 18,
        left12Top: 454,
        left12Left: 581,

        left13Width: 18,
        left13Height: 18,
        left13Top: 483,
        left13Left: 582,

        left14Width: 18,
        left14Height: 18,
        left14Top: 511,
        left14Left: 582,

        right1Width: 18,
        right1Height: 18,
        right1Top: 130,
        right1Left: 236,

        right2Width: 18,
        right2Height: 18,
        right2Top: 159,
        right2Left: 236,

        right3Width: 18,
        right3Height: 18,
        right3Top: 189,
        right3Left: 236,

        right4Width: 16,
        right4Height: 18,
        right4Top: 217,
        right4Left: 237,

        right5Width: 18,
        right5Height: 18,
        right5Top: 246,
        right5Left: 237,

        right6Width: 18,
        right6Height: 18,
        right6Top: 275,
        right6Left: 237,

        right7Width: 18,
        right7Height: 18,
        right7Top: 303,
        right7Left: 237,

        right8Width: 18,
        right8Height: 18,
        right8Top: 335,
        right8Left: 233,

        right9Width: 18,
        right9Height: 18,
        right9Top: 365,
        right9Left: 234,

        right10Width: 18,
        right10Height: 18,
        right10Top: 393,
        right10Left: 235,

        right11Width: 18,
        right11Height: 18,
        right11Top: 423,
        right11Left: 235,

        right12Width: 18,
        right12Height: 18,
        right12Top: 454,
        right12Left: 235,

        right13Width: 18,
        right13Height: 18,
        right13Top: 483,
        right13Left: 236,

        right14Width: 18,
        right14Height: 18,
        right14Top: 513,
        right14Left: 236,
      },
      bg: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 128,
        headerTop: 38,

        wordwrap: 'break-word',
        lineHeight: 10,
        letterspacing: -0.1,
        textResize: 12,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 18,
        left3Height: 18,
        left3Top: 190,
        left3Left: 52,

        left4Width: 18,
        left4Height: 18,
        left4Top: 219,
        left4Left: 52,

        left5Width: 18,
        left5Height: 18,
        left5Top: 248,
        left5Left: 52,

        left6Width: 18,
        left6Height: 18,
        left6Top: 277,
        left6Left: 52,

        left7Width: 18,
        left7Height: 18,
        left7Top: 306,
        left7Left: 52,

        left8Width: 18,
        left8Height: 18,
        left8Top: 337,
        left8Left: 52,

        left9Width: 18,
        left9Height: 18,
        left9Top: 367,
        left9Left: 52,

        left10Width: 18,
        left10Height: 18,
        left10Top: 395,
        left10Left: 52,

        left11Width: 18,
        left11Height: 18,
        left11Top: 424,
        left11Left: 52,

        left12Width: 18,
        left12Height: 18,
        left12Top: 453,
        left12Left: 52,

        left13Width: 18,
        left13Height: 18,
        left13Top: 482,
        left13Left: 52,

        left14Width: 18,
        left14Height: 18,
        left14Top: 511,
        left14Left: 52,

        right1Width: 18,
        right1Height: 18,
        right1Top: 132,
        right1Left: 408,

        right2Width: 18,
        right2Height: 18,
        right2Top: 161,
        right2Left: 408,

        right3Width: 18,
        right3Height: 18,
        right3Top: 190,
        right3Left: 408,

        right4Width: 18,
        right4Height: 18,
        right4Top: 219,
        right4Left: 408,

        right5Width: 18,
        right5Height: 18,
        right5Top: 247,
        right5Left: 408,

        right6Width: 18,
        right6Height: 18,
        right6Top: 278,
        right6Left: 408,

        right7Width: 18,
        right7Height: 18,
        right7Top: 307,
        right7Left: 408,

        right8Width: 18,
        right8Height: 18,
        right8Top: 335,
        right8Left: 405,

        right9Width: 33,
        right9Height: 18,
        right9Top: 363,
        right9Left: 400,

        right10Width: 33,
        right10Height: 18,
        right10Top: 392,
        right10Left: 400,

        right11Width: 33,
        right11Height: 18,
        right11Top: 421,
        right11Left: 400,

        right12Width: 33,
        right12Height: 18,
        right12Top: 452,
        right12Left: 400,

        right13Width: 18,
        right13Height: 18,
        right13Top: 483,
        right13Left: 408,

        right14Width: 18,
        right14Height: 18,
        right14Top: 512,
        right14Left: 409,
      },
      cs: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 121,
        headerTop: 37,

        wordwrap: 'break-word',
        lineHeight: 10,
        letterspacing: -0.1,
        textResize: 12,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 18,
        left3Height: 18,
        left3Top: 190,
        left3Left: 52,

        left4Width: 18,
        left4Height: 18,
        left4Top: 220,
        left4Left: 52,

        left5Width: 18,
        left5Height: 18,
        left5Top: 249,
        left5Left: 52,

        left6Width: 18,
        left6Height: 18,
        left6Top: 278,
        left6Left: 51,

        left7Width: 18,
        left7Height: 18,
        left7Top: 307,
        left7Left: 52,

        left8Width: 18,
        left8Height: 18,
        left8Top: 338,
        left8Left: 52,

        left9Width: 18,
        left9Height: 18,
        left9Top: 367,
        left9Left: 52,

        left10Width: 18,
        left10Height: 18,
        left10Top: 395,
        left10Left: 52,

        left11Width: 18,
        left11Height: 18,
        left11Top: 425,
        left11Left: 52,

        left12Width: 18,
        left12Height: 18,
        left12Top: 454,
        left12Left: 52,

        left13Width: 18,
        left13Height: 18,
        left13Top: 482,
        left13Left: 52,

        left14Width: 18,
        left14Height: 18,
        left14Top: 510,
        left14Left: 52,

        right1Width: 18,
        right1Height: 18,
        right1Top: 132,
        right1Left: 408,

        right2Width: 18,
        right2Height: 18,
        right2Top: 162,
        right2Left: 408,

        right3Width: 18,
        right3Height: 18,
        right3Top: 190,
        right3Left: 408,

        right4Width: 18,
        right4Height: 18,
        right4Top: 219,
        right4Left: 408,

        right5Width: 18,
        right5Height: 18,
        right5Top: 248,
        right5Left: 408,

        right6Width: 18,
        right6Height: 18,
        right6Top: 277,
        right6Left: 408,

        right7Width: 18,
        right7Height: 18,
        right7Top: 307,
        right7Left: 408,

        right8Width: 18,
        right8Height: 18,
        right8Top: 334,
        right8Left: 404,

        right9Width: 34,
        right9Height: 18,
        right9Top: 364,
        right9Left: 400,

        right10Width: 34,
        right10Height: 18,
        right10Top: 392,
        right10Left: 400,

        right11Width: 34,
        right11Height: 18,
        right11Top: 422,
        right11Left: 400,

        right12Width: 34,
        right12Height: 18,
        right12Top: 452,
        right12Left: 400,

        right13Width: 18,
        right13Height: 18,
        right13Top: 481,
        right13Left: 408,

        right14Width: 18,
        right14Height: 18,
        right14Top: 510,
        right14Left: 408,
      },
      da: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 129,
        headerTop: 33,

        wordwrap: 'break-word',
        lineHeight: 10,
        letterspacing: -0.1,
        textResize: 11,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 18,
        left3Height: 18,
        left3Top: 189,
        left3Left: 53,

        left4Width: 18,
        left4Height: 18,
        left4Top: 219,
        left4Left: 53,

        left5Width: 18,
        left5Height: 18,
        left5Top: 248,
        left5Left: 53,

        left6Width: 18,
        left6Height: 18,
        left6Top: 278,
        left6Left: 53,

        left7Width: 18,
        left7Height: 18,
        left7Top: 306,
        left7Left: 53,

        left8Width: 18,
        left8Height: 18,
        left8Top: 337,
        left8Left: 53,

        left9Width: 18,
        left9Height: 18,
        left9Top: 365,
        left9Left: 53,

        left10Width: 18,
        left10Height: 18,
        left10Top: 395,
        left10Left: 53,

        left11Width: 18,
        left11Height: 18,
        left11Top: 424,
        left11Left: 53,

        left12Width: 18,
        left12Height: 18,
        left12Top: 454,
        left12Left: 53,

        left13Width: 18,
        left13Height: 18,
        left13Top: 482,
        left13Left: 53,

        left14Width: 18,
        left14Height: 18,
        left14Top: 511,
        left14Left: 53,

        right1Width: 18,
        right1Height: 18,
        right1Top: 132,
        right1Left: 407,

        right2Width: 18,
        right2Height: 18,
        right2Top: 162,
        right2Left: 407,

        right3Width: 18,
        right3Height: 18,
        right3Top: 189,
        right3Left: 407,

        right4Width: 18,
        right4Height: 18,
        right4Top: 219,
        right4Left: 407,

        right5Width: 18,
        right5Height: 18,
        right5Top: 248,
        right5Left: 407,

        right6Width: 18,
        right6Height: 18,
        right6Top: 277,
        right6Left: 407,

        right7Width: 18,
        right7Height: 18,
        right7Top: 307,
        right7Left: 407,

        right8Width: 27,
        right8Height: 18,
        right8Top: 334,
        right8Left: 403,

        right9Width: 35,
        right9Height: 18,
        right9Top: 365,
        right9Left: 399,

        right10Width: 35,
        right10Height: 18,
        right10Top: 394,
        right10Left: 399,

        right11Width: 35,
        right11Height: 18,
        right11Top: 423,
        right11Left: 399,

        right12Width: 35,
        right12Height: 18,
        right12Top: 453,
        right12Left: 399,

        right13Width: 18,
        right13Height: 18,
        right13Top: 482,
        right13Left: 407,

        right14Width: 18,
        right14Height: 18,
        right14Top: 511,
        right14Left: 407,
      },
      de: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 148,
        headerTop: 38,

        wordwrap: 'break-word',
        lineHeight: 8,
        letterspacing: -0.1,
        textResize: 12,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 18,
        left3Height: 18,
        left3Top: 190,
        left3Left: 53,

        left4Width: 18,
        left4Height: 18,
        left4Top: 219,
        left4Left: 53,

        left5Width: 18,
        left5Height: 18,
        left5Top: 248,
        left5Left: 53,

        left6Width: 18,
        left6Height: 18,
        left6Top: 278,
        left6Left: 53,

        left7Width: 18,
        left7Height: 18,
        left7Top: 307,
        left7Left: 53,

        left8Width: 18,
        left8Height: 18,
        left8Top: 338,
        left8Left: 53,

        left9Width: 18,
        left9Height: 18,
        left9Top: 367,
        left9Left: 53,

        left10Width: 18,
        left10Height: 18,
        left10Top: 396,
        left10Left: 53,

        left11Width: 18,
        left11Height: 18,
        left11Top: 424,
        left11Left: 53,

        left12Width: 18,
        left12Height: 18,
        left12Top: 454,
        left12Left: 53,

        left13Width: 18,
        left13Height: 18,
        left13Top: 483,
        left13Left: 53,

        left14Width: 18,
        left14Height: 18,
        left14Top: 511,
        left14Left: 53,

        right1Width: 18,
        right1Height: 18,
        right1Top: 133,
        right1Left: 408,

        right2Width: 18,
        right2Height: 18,
        right2Top: 162,
        right2Left: 408,

        right3Width: 18,
        right3Height: 18,
        right3Top: 190,
        right3Left: 408,

        right4Width: 18,
        right4Height: 18,
        right4Top: 219,
        right4Left: 407,

        right5Width: 18,
        right5Height: 18,
        right5Top: 248,
        right5Left: 407,

        right6Width: 18,
        right6Height: 18,
        right6Top: 277,
        right6Left: 407,

        right7Width: 18,
        right7Height: 18,
        right7Top: 307,
        right7Left: 407,

        right8Width: 18,
        right8Height: 18,
        right8Top: 335,
        right8Left: 405,

        right9Width: 22,
        right9Height: 18,
        right9Top: 366,
        right9Left: 406,

        right10Width: 22,
        right10Height: 18,
        right10Top: 395,
        right10Left: 406,

        right11Width: 22,
        right11Height: 18,
        right11Top: 424,
        right11Left: 406,

        right12Width: 22,
        right12Height: 18,
        right12Top: 455,
        right12Left: 406,

        right13Width: 18,
        right13Height: 18,
        right13Top: 481,
        right13Left: 408,

        right14Width: 18,
        right14Height: 18,
        right14Top: 510,
        right14Left: 408,
      },
      ee: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 149,
        headerTop: 37,

        wordwrap: 'normal',
        lineHeight: 0,
        letterspacing: 0,
        textResize: 11,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 18,
        left3Height: 18,
        left3Top: 189,
        left3Left: 52,

        left4Width: 18,
        left4Height: 18,
        left4Top: 218,
        left4Left: 52,

        left5Width: 18,
        left5Height: 18,
        left5Top: 247,
        left5Left: 52,

        left6Width: 18,
        left6Height: 18,
        left6Top: 276,
        left6Left: 52,

        left7Width: 18,
        left7Height: 18,
        left7Top: 305,
        left7Left: 52,

        left8Width: 18,
        left8Height: 18,
        left8Top: 336,
        left8Left: 52,

        left9Width: 18,
        left9Height: 18,
        left9Top: 366,
        left9Left: 52,

        left10Width: 18,
        left10Height: 18,
        left10Top: 395,
        left10Left: 52,

        left11Width: 18,
        left11Height: 18,
        left11Top: 424,
        left11Left: 52,

        left12Width: 18,
        left12Height: 18,
        left12Top: 454,
        left12Left: 52,

        left13Width: 18,
        left13Height: 18,
        left13Top: 483,
        left13Left: 52,

        left14Width: 18,
        left14Height: 18,
        left14Top: 510,
        left14Left: 52,

        right1Width: 18,
        right1Height: 18,
        right1Top: 132,
        right1Left: 426,

        right2Width: 18,
        right2Height: 18,
        right2Top: 161,
        right2Left: 426,

        right3Width: 18,
        right3Height: 18,
        right3Top: 190,
        right3Left: 426,

        right4Width: 18,
        right4Height: 18,
        right4Top: 218,
        right4Left: 426,

        right5Width: 18,
        right5Height: 18,
        right5Top: 248,
        right5Left: 426,

        right6Width: 18,
        right6Height: 18,
        right6Top: 277,
        right6Left: 426,

        right7Width: 18,
        right7Height: 18,
        right7Top: 306,
        right7Left: 426,

        right8Width: 28,
        right8Height: 18,
        right8Top: 334,
        right8Left: 420,

        right9Width: 35,
        right9Height: 18,
        right9Top: 374,
        right9Left: 418,

        right10Width: 35,
        right10Height: 18,
        right10Top: 402,
        right10Left: 418,

        right11Width: 35,
        right11Height: 18,
        right11Top: 431,
        right11Left: 418,

        right12Width: 35,
        right12Height: 18,
        right12Top: 462,
        right12Left: 418,

        right13Width: 18,
        right13Height: 18,
        right13Top: 482,
        right13Left: 426,

        right14Width: 18,
        right14Height: 18,
        right14Top: 510,
        right14Left: 426,
      },
      en: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 148,
        headerTop: 37,

        wordwrap: 'normal',
        lineHeight: 0,
        letterspacing: -0.05,
        textResize: 11,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 18,
        left3Height: 18,
        left3Top: 190,
        left3Left: 53,

        left4Width: 18,
        left4Height: 18,
        left4Top: 218,
        left4Left: 53,

        left5Width: 18,
        left5Height: 18,
        left5Top: 247,
        left5Left: 53,

        left6Width: 18,
        left6Height: 18,
        left6Top: 277,
        left6Left: 53,

        left7Width: 18,
        left7Height: 18,
        left7Top: 306,
        left7Left: 53,

        left8Width: 18,
        left8Height: 18,
        left8Top: 337,
        left8Left: 53,

        left9Width: 18,
        left9Height: 18,
        left9Top: 366,
        left9Left: 53,

        left10Width: 18,
        left10Height: 18,
        left10Top: 395,
        left10Left: 53,

        left11Width: 18,
        left11Height: 18,
        left11Top: 424,
        left11Left: 53,

        left12Width: 18,
        left12Height: 18,
        left12Top: 454,
        left12Left: 53,

        left13Width: 18,
        left13Height: 18,
        left13Top: 482,
        left13Left: 53,

        left14Width: 18,
        left14Height: 18,
        left14Top: 511,
        left14Left: 53,

        right1Width: 18,
        right1Height: 18,
        right1Top: 132,
        right1Left: 407,

        right2Width: 18,
        right2Height: 18,
        right2Top: 161,
        right2Left: 407,

        right3Width: 18,
        right3Height: 18,
        right3Top: 190,
        right3Left: 407,

        right4Width: 18,
        right4Height: 18,
        right4Top: 219,
        right4Left: 407,

        right5Width: 18,
        right5Height: 18,
        right5Top: 249,
        right5Left: 407,

        right6Width: 18,
        right6Height: 18,
        right6Top: 277,
        right6Left: 407,

        right7Width: 18,
        right7Height: 18,
        right7Top: 306,
        right7Left: 407,

        right8Width: 28,
        right8Height: 18,
        right8Top: 334,
        right8Left: 402,

        right9Width: 35,
        right9Height: 18,
        right9Top: 373,
        right9Left: 399,

        right10Width: 35,
        right10Height: 18,
        right10Top: 401,
        right10Left: 399,

        right11Width: 35,
        right11Height: 18,
        right11Top: 431,
        right11Left: 399,

        right12Width: 35,
        right12Height: 18,
        right12Top: 462,
        right12Left: 399,

        right13Width: 18,
        right13Height: 18,
        right13Top: 482,
        right13Left: 407,

        right14Width: 18,
        right14Height: 18,
        right14Top: 511,
        right14Left: 407,
      },
      es: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 136,
        headerTop: 37,

        wordwrap: 'break-word',
        lineHeight: 7,
        letterspacing: -0.08,
        textResize: 12,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 18,
        left3Height: 18,
        left3Top: 190,
        left3Left: 53,

        left4Width: 18,
        left4Height: 18,
        left4Top: 219,
        left4Left: 53,

        left5Width: 18,
        left5Height: 18,
        left5Top: 248,
        left5Left: 53,

        left6Width: 18,
        left6Height: 18,
        left6Top: 278,
        left6Left: 53,

        left7Width: 18,
        left7Height: 18,
        left7Top: 307,
        left7Left: 53,

        left8Width: 18,
        left8Height: 18,
        left8Top: 338,
        left8Left: 53,

        left9Width: 18,
        left9Height: 18,
        left9Top: 367,
        left9Left: 53,

        left10Width: 18,
        left10Height: 18,
        left10Top: 396,
        left10Left: 53,

        left11Width: 18,
        left11Height: 18,
        left11Top: 424,
        left11Left: 53,

        left12Width: 18,
        left12Height: 18,
        left12Top: 453,
        left12Left: 53,

        left13Width: 18,
        left13Height: 18,
        left13Top: 483,
        left13Left: 53,

        left14Width: 18,
        left14Height: 18,
        left14Top: 511,
        left14Left: 53,

        right1Width: 18,
        right1Height: 18,
        right1Top: 133,
        right1Left: 408,

        right2Width: 18,
        right2Height: 18,
        right2Top: 163,
        right2Left: 408,

        right3Width: 18,
        right3Height: 18,
        right3Top: 191,
        right3Left: 408,

        right4Width: 18,
        right4Height: 18,
        right4Top: 219,
        right4Left: 408,

        right5Width: 18,
        right5Height: 18,
        right5Top: 248,
        right5Left: 408,

        right6Width: 18,
        right6Height: 18,
        right6Top: 278,
        right6Left: 408,

        right7Width: 18,
        right7Height: 18,
        right7Top: 307,
        right7Left: 408,

        right8Width: 18,
        right8Height: 18,
        right8Top: 334,
        right8Left: 405,

        right9Width: 32,
        right9Height: 18,
        right9Top: 368,
        right9Left: 400,

        right10Width: 32,
        right10Height: 18,
        right10Top: 396,
        right10Left: 400,

        right11Width: 32,
        right11Height: 18,
        right11Top: 426,
        right11Left: 400,

        right12Width: 32,
        right12Height: 18,
        right12Top: 457,
        right12Left: 400,

        right13Width: 18,
        right13Height: 18,
        right13Top: 483,
        right13Left: 408,

        right14Width: 18,
        right14Height: 18,
        right14Top: 510,
        right14Left: 408,
      },
      fi: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 126,
        headerTop: 40,

        wordwrap: 'break-word',
        lineHeight: 8,
        letterspacing: -0.1,
        textResize: 12,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 18,
        left3Height: 18,
        left3Top: 190,
        left3Left: 53,

        left4Width: 18,
        left4Height: 18,
        left4Top: 219,
        left4Left: 53,

        left5Width: 18,
        left5Height: 18,
        left5Top: 248,
        left5Left: 53,

        left6Width: 18,
        left6Height: 18,
        left6Top: 277,
        left6Left: 53,

        left7Width: 18,
        left7Height: 18,
        left7Top: 306,
        left7Left: 53,

        left8Width: 18,
        left8Height: 18,
        left8Top: 337,
        left8Left: 53,

        left9Width: 18,
        left9Height: 18,
        left9Top: 366,
        left9Left: 53,

        left10Width: 18,
        left10Height: 18,
        left10Top: 394,
        left10Left: 53,

        left11Width: 18,
        left11Height: 18,
        left11Top: 423,
        left11Left: 53,

        left12Width: 18,
        left12Height: 18,
        left12Top: 453,
        left12Left: 53,

        left13Width: 18,
        left13Height: 18,
        left13Top: 482,
        left13Left: 53,

        left14Width: 18,
        left14Height: 18,
        left14Top: 511,
        left14Left: 53,

        right1Width: 18,
        right1Height: 18,
        right1Top: 132,
        right1Left: 407,

        right2Width: 18,
        right2Height: 18,
        right2Top: 162,
        right2Left: 407,

        right3Width: 18,
        right3Height: 18,
        right3Top: 190,
        right3Left: 407,

        right4Width: 18,
        right4Height: 18,
        right4Top: 218,
        right4Left: 407,

        right5Width: 18,
        right5Height: 18,
        right5Top: 249,
        right5Left: 407,

        right6Width: 18,
        right6Height: 18,
        right6Top: 277,
        right6Left: 407,

        right7Width: 18,
        right7Height: 18,
        right7Top: 306,
        right7Left: 407,

        right8Width: 18,
        right8Height: 18,
        right8Top: 334,
        right8Left: 405,

        right9Width: 33,
        right9Height: 18,
        right9Top: 367,
        right9Left: 400,

        right10Width: 33,
        right10Height: 18,
        right10Top: 395,
        right10Left: 400,

        right11Width: 33,
        right11Height: 18,
        right11Top: 425,
        right11Left: 400,

        right12Width: 33,
        right12Height: 18,
        right12Top: 456,
        right12Left: 400,

        right13Width: 18,
        right13Height: 18,
        right13Top: 481,
        right13Left: 408,

        right14Width: 18,
        right14Height: 18,
        right14Top: 510,
        right14Left: 408,
      },
      fr: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 122,
        headerTop: 41,

        wordwrap: 'break-word',
        lineHeight: 8,
        letterspacing: -0.1,
        textResize: 12,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 18,
        left3Height: 18,
        left3Top: 190,
        left3Left: 53,

        left4Width: 18,
        left4Height: 18,
        left4Top: 220,
        left4Left: 53,

        left5Width: 18,
        left5Height: 18,
        left5Top: 251,
        left5Left: 53,

        left6Width: 18,
        left6Height: 18,
        left6Top: 276,
        left6Left: 52,

        left7Width: 18,
        left7Height: 18,
        left7Top: 304,
        left7Left: 53,

        left8Width: 18,
        left8Height: 18,
        left8Top: 338,
        left8Left: 53,

        left9Width: 18,
        left9Height: 18,
        left9Top: 366,
        left9Left: 53,

        left10Width: 18,
        left10Height: 18,
        left10Top: 394,
        left10Left: 53,

        left11Width: 18,
        left11Height: 18,
        left11Top: 424,
        left11Left: 53,

        left12Width: 18,
        left12Height: 18,
        left12Top: 452,
        left12Left: 53,

        left13Width: 18,
        left13Height: 18,
        left13Top: 482,
        left13Left: 53,

        left14Width: 18,
        left14Height: 18,
        left14Top: 511,
        left14Left: 53,

        right1Width: 18,
        right1Height: 18,
        right1Top: 133,
        right1Left: 408,

        right2Width: 18,
        right2Height: 18,
        right2Top: 161,
        right2Left: 408,

        right3Width: 18,
        right3Height: 18,
        right3Top: 190,
        right3Left: 408,

        right4Width: 18,
        right4Height: 18,
        right4Top: 219,
        right4Left: 408,

        right5Width: 18,
        right5Height: 18,
        right5Top: 248,
        right5Left: 408,

        right6Width: 18,
        right6Height: 18,
        right6Top: 277,
        right6Left: 408,

        right7Width: 18,
        right7Height: 18,
        right7Top: 307,
        right7Left: 408,

        right8Width: 18,
        right8Height: 18,
        right8Top: 334,
        right8Left: 405,

        right9Width: 33,
        right9Height: 18,
        right9Top: 367,
        right9Left: 400,

        right10Width: 33,
        right10Height: 18,
        right10Top: 395,
        right10Left: 400,

        right11Width: 33,
        right11Height: 18,
        right11Top: 425,
        right11Left: 400,

        right12Width: 33,
        right12Height: 18,
        right12Top: 456,
        right12Left: 400,

        right13Width: 18,
        right13Height: 18,
        right13Top: 481,
        right13Left: 408,

        right14Width: 18,
        right14Height: 18,
        right14Top: 510,
        right14Left: 408,
      },
      ge: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 127,
        headerTop: 40,

        wordwrap: 'normal',
        lineHeight: 0,
        letterspacing: 0,
        textResize: 11,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 18,
        left3Height: 18,
        left3Top: 190,
        left3Left: 52,

        left4Width: 18,
        left4Height: 18,
        left4Top: 218,
        left4Left: 52,

        left5Width: 18,
        left5Height: 18,
        left5Top: 247,
        left5Left: 52,

        left6Width: 18,
        left6Height: 18,
        left6Top: 276,
        left6Left: 52,

        left7Width: 18,
        left7Height: 18,
        left7Top: 304,
        left7Left: 52,

        left8Width: 18,
        left8Height: 18,
        left8Top: 336,
        left8Left: 52,

        left9Width: 18,
        left9Height: 18,
        left9Top: 366,
        left9Left: 52,

        left10Width: 18,
        left10Height: 18,
        left10Top: 395,
        left10Left: 52,

        left11Width: 18,
        left11Height: 18,
        left11Top: 424,
        left11Left: 52,

        left12Width: 18,
        left12Height: 18,
        left12Top: 454,
        left12Left: 52,

        left13Width: 18,
        left13Height: 18,
        left13Top: 483,
        left13Left: 52,

        left14Width: 18,
        left14Height: 18,
        left14Top: 511,
        left14Left: 52,

        right1Width: 18,
        right1Height: 18,
        right1Top: 132,
        right1Left: 408,

        right2Width: 18,
        right2Height: 18,
        right2Top: 158,
        right2Left: 408,

        right3Width: 18,
        right3Height: 18,
        right3Top: 186,
        right3Left: 408,

        right4Width: 18,
        right4Height: 18,
        right4Top: 215,
        right4Left: 408,

        right5Width: 18,
        right5Height: 18,
        right5Top: 248,
        right5Left: 408,

        right6Width: 18,
        right6Height: 18,
        right6Top: 275,
        right6Left: 408,

        right7Width: 18,
        right7Height: 18,
        right7Top: 306,
        right7Left: 408,

        right8Width: 28,
        right8Height: 18,
        right8Top: 334,
        right8Left: 402,

        right9Width: 35,
        right9Height: 18,
        right9Top: 371,
        right9Left: 399,

        right10Width: 35,
        right10Height: 18,
        right10Top: 400,
        right10Left: 399,

        right11Width: 35,
        right11Height: 18,
        right11Top: 429,
        right11Left: 399,

        right12Width: 35,
        right12Height: 18,
        right12Top: 460,
        right12Left: 399,

        right13Width: 18,
        right13Height: 18,
        right13Top: 480,
        right13Left: 408,

        right14Width: 18,
        right14Height: 18,
        right14Top: 511,
        right14Left: 408,
      },
      gr: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 128,
        headerTop: 38,

        wordwrap: 'normal',
        lineHeight: 0,
        letterspacing: -0.05,
        textResize: 11,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 18,
        left3Height: 18,
        left3Top: 190,
        left3Left: 52,

        left4Width: 18,
        left4Height: 18,
        left4Top: 219,
        left4Left: 52,

        left5Width: 18,
        left5Height: 18,
        left5Top: 248,
        left5Left: 52,

        left6Width: 18,
        left6Height: 18,
        left6Top: 277,
        left6Left: 52,

        left7Width: 18,
        left7Height: 18,
        left7Top: 305,
        left7Left: 52,

        left8Width: 18,
        left8Height: 18,
        left8Top: 337,
        left8Left: 52,

        left9Width: 18,
        left9Height: 18,
        left9Top: 367,
        left9Left: 52,

        left10Width: 18,
        left10Height: 18,
        left10Top: 395,
        left10Left: 52,

        left11Width: 18,
        left11Height: 18,
        left11Top: 424,
        left11Left: 53,

        left12Width: 18,
        left12Height: 18,
        left12Top: 453,
        left12Left: 52,

        left13Width: 18,
        left13Height: 18,
        left13Top: 482,
        left13Left: 52,

        left14Width: 18,
        left14Height: 18,
        left14Top: 511,
        left14Left: 52,

        right1Width: 18,
        right1Height: 18,
        right1Top: 132,
        right1Left: 408,

        right2Width: 18,
        right2Height: 18,
        right2Top: 161,
        right2Left: 408,

        right3Width: 18,
        right3Height: 18,
        right3Top: 190,
        right3Left: 408,

        right4Width: 18,
        right4Height: 18,
        right4Top: 218,
        right4Left: 408,

        right5Width: 18,
        right5Height: 18,
        right5Top: 249,
        right5Left: 408,

        right6Width: 18,
        right6Height: 18,
        right6Top: 277,
        right6Left: 408,

        right7Width: 18,
        right7Height: 18,
        right7Top: 307,
        right7Left: 408,

        right8Width: 38,
        right8Height: 18,
        right8Top: 334,
        right8Left: 398,

        right9Width: 35,
        right9Height: 18,
        right9Top: 371,
        right9Left: 399,

        right10Width: 35,
        right10Height: 18,
        right10Top: 400,
        right10Left: 399,

        right11Width: 35,
        right11Height: 18,
        right11Top: 429,
        right11Left: 399,

        right12Width: 35,
        right12Height: 18,
        right12Top: 460,
        right12Left: 399,

        right13Width: 18,
        right13Height: 18,
        right13Top: 484,
        right13Left: 408,

        right14Width: 18,
        right14Height: 18,
        right14Top: 512,
        right14Left: 408,
      },
      he: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 473,
        headerTop: 37,

        wordwrap: 'normal',
        lineHeight: 8,
        letterspacing: 0,
        textResize: 10,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 18,
        left3Height: 18,
        left3Top: 190,
        left3Left: 572,

        left4Width: 18,
        left4Height: 18,
        left4Top: 219,
        left4Left: 572,

        left5Width: 18,
        left5Height: 18,
        left5Top: 248,
        left5Left: 572,

        left6Width: 18,
        left6Height: 18,
        left6Top: 277,
        left6Left: 572,

        left7Width: 18,
        left7Height: 18,
        left7Top: 306,
        left7Left: 572,

        left8Width: 18,
        left8Height: 18,
        left8Top: 337,
        left8Left: 572,

        left9Width: 18,
        left9Height: 18,
        left9Top: 367,
        left9Left: 572,

        left10Width: 18,
        left10Height: 18,
        left10Top: 395,
        left10Left: 572,

        left11Width: 18,
        left11Height: 18,
        left11Top: 424,
        left11Left: 572,

        left12Width: 18,
        left12Height: 18,
        left12Top: 453,
        left12Left: 572,

        left13Width: 18,
        left13Height: 18,
        left13Top: 479,
        left13Left: 572,

        left14Width: 18,
        left14Height: 18,
        left14Top: 509,
        left14Left: 572,

        right1Width: 18,
        right1Height: 18,
        right1Top: 131,
        right1Left: 226,

        right2Width: 18,
        right2Height: 18,
        right2Top: 160,
        right2Left: 226,

        right3Width: 18,
        right3Height: 18,
        right3Top: 189,
        right3Left: 226,

        right4Width: 18,
        right4Height: 18,
        right4Top: 217,
        right4Left: 226,

        right5Width: 18,
        right5Height: 18,
        right5Top: 246,
        right5Left: 227,

        right6Width: 18,
        right6Height: 18,
        right6Top: 277,
        right6Left: 226,

        right7Width: 18,
        right7Height: 18,
        right7Top: 305,
        right7Left: 226,

        right8Width: 40,
        right8Height: 18,
        right8Top: 334,
        right8Left: 216,

        right9Width: 38,
        right9Height: 18,
        right9Top: 365,
        right9Left: 217,

        right10Width: 38,
        right10Height: 18,
        right10Top: 423,
        right10Left: 217,

        right11Width: 38,
        right11Height: 18,
        right11Top: 394,
        right11Left: 217,

        right12Width: 38,
        right12Height: 18,
        right12Top: 454,
        right12Left: 217,

        right13Width: 18,
        right13Height: 18,
        right13Top: 482,
        right13Left: 226,

        right14Width: 18,
        right14Height: 18,
        right14Top: 511,
        right14Left: 226,
      },
      'hi-IN': {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 178,
        headerTop: 39,

        wordwrap: 'normal',
        lineHeight: 9,
        letterspacing: -0.1,
        right4letterspacing: -0.05,
        textResize: 11,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 18,
        left3Height: 18,
        left3Top: 190,
        left3Left: 57,

        left4Width: 18,
        left4Height: 18,
        left4Top: 219,
        left4Left: 57,

        left5Width: 18,
        left5Height: 18,
        left5Top: 248,
        left5Left: 58,

        left6Width: 18,
        left6Height: 18,
        left6Top: 277,
        left6Left: 58,

        left7Width: 18,
        left7Height: 18,
        left7Top: 305,
        left7Left: 57,

        left8Width: 18,
        left8Height: 18,
        left8Top: 337,
        left8Left: 57,

        left9Width: 18,
        left9Height: 18,
        left9Top: 366,
        left9Left: 58,

        left10Width: 18,
        left10Height: 18,
        left10Top: 394,
        left10Left: 57,

        left11Width: 18,
        left11Height: 18,
        left11Top: 423,
        left11Left: 57,

        left12Width: 18,
        left12Height: 18,
        left12Top: 454,
        left12Left: 58,

        left13Width: 18,
        left13Height: 18,
        left13Top: 482,
        left13Left: 57,

        left14Width: 18,
        left14Height: 18,
        left14Top: 511,
        left14Left: 57,

        right1Width: 18,
        right1Height: 18,
        right1Top: 133,
        right1Left: 401,

        right2Width: 18,
        right2Height: 18,
        right2Top: 162,
        right2Left: 401,

        right3Width: 18,
        right3Height: 18,
        right3Top: 190,
        right3Left: 401,

        right4Width: 18,
        right4Height: 18,
        right4Top: 219,
        right4Left: 401,

        right5Width: 18,
        right5Height: 18,
        right5Top: 248,
        right5Left: 401,

        right6Width: 18,
        right6Height: 18,
        right6Top: 278,
        right6Left: 401,

        right7Width: 18,
        right7Height: 18,
        right7Top: 307,
        right7Left: 401,

        right8Width: 39,
        right8Height: 18,
        right8Top: 334,
        right8Left: 391,

        right9Width: 39,
        right9Height: 18,
        right9Top: 371,
        right9Left: 391,

        right10Width: 39,
        right10Height: 18,
        right10Top: 400,
        right10Left: 391,

        right11Width: 39,
        right11Height: 18,
        right11Top: 429,
        right11Left: 391,

        right12Width: 39,
        right12Height: 18,
        right12Top: 459,
        right12Left: 391,

        right13Width: 18,
        right13Height: 18,
        right13Top: 484,
        right13Left: 401,

        right14Width: 18,
        right14Height: 18,
        right14Top: 513,
        right14Left: 401,
      },
      hu: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 133,
        headerTop: 40,

        wordwrap: 'normal',
        lineHeight: 0,
        letterspacing: -0.1,
        textResize: 11,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 18,
        left3Height: 18,
        left3Top: 190,
        left3Left: 53,

        left4Width: 18,
        left4Height: 18,
        left4Top: 219,
        left4Left: 53,

        left5Width: 18,
        left5Height: 18,
        left5Top: 247,
        left5Left: 53,

        left6Width: 18,
        left6Height: 18,
        left6Top: 277,
        left6Left: 53,

        left7Width: 18,
        left7Height: 18,
        left7Top: 306,
        left7Left: 53,

        left8Width: 18,
        left8Height: 18,
        left8Top: 337,
        left8Left: 53,

        left9Width: 18,
        left9Height: 18,
        left9Top: 366,
        left9Left: 53,

        left10Width: 18,
        left10Height: 18,
        left10Top: 395,
        left10Left: 53,

        left11Width: 18,
        left11Height: 18,
        left11Top: 424,
        left11Left: 53,

        left12Width: 18,
        left12Height: 18,
        left12Top: 454,
        left12Left: 53,

        left13Width: 18,
        left13Height: 18,
        left13Top: 483,
        left13Left: 53,

        left14Width: 18,
        left14Height: 18,
        left14Top: 511,
        left14Left: 53,

        right1Width: 18,
        right1Height: 18,
        right1Top: 132,
        right1Left: 407,

        right2Width: 18,
        right2Height: 18,
        right2Top: 161,
        right2Left: 407,

        right3Width: 18,
        right3Height: 18,
        right3Top: 190,
        right3Left: 407,

        right4Width: 18,
        right4Height: 18,
        right4Top: 219,
        right4Left: 407,

        right5Width: 18,
        right5Height: 18,
        right5Top: 248,
        right5Left: 407,

        right6Width: 18,
        right6Height: 18,
        right6Top: 277,
        right6Left: 407,

        right7Width: 18,
        right7Height: 18,
        right7Top: 306,
        right7Left: 407,

        right8Width: 28,
        right8Height: 18,
        right8Top: 334,
        right8Left: 402,

        right9Width: 35,
        right9Height: 18,
        right9Top: 373,
        right9Left: 399,

        right10Width: 35,
        right10Height: 18,
        right10Top: 402,
        right10Left: 399,

        right11Width: 35,
        right11Height: 18,
        right11Top: 431,
        right11Left: 399,

        right12Width: 35,
        right12Height: 18,
        right12Top: 462,
        right12Left: 399,

        right13Width: 18,
        right13Height: 18,
        right13Top: 482,
        right13Left: 407,

        right14Width: 18,
        right14Height: 18,
        right14Top: 510,
        right14Left: 407,
      },
      hy: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 128,
        headerTop: 38,

        wordwrap: 'break-word',
        lineHeight: 8,
        letterspacing: -0.1,
        textResize: 9,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 18,
        left3Height: 18,
        left3Top: 190,
        left3Left: 50,

        left4Width: 18,
        left4Height: 18,
        left4Top: 220,
        left4Left: 50,

        left5Width: 18,
        left5Height: 18,
        left5Top: 249,
        left5Left: 50,

        left6Width: 18,
        left6Height: 18,
        left6Top: 277,
        left6Left: 50,

        left7Width: 18,
        left7Height: 18,
        left7Top: 306,
        left7Left: 50,

        left8Width: 18,
        left8Height: 18,
        left8Top: 337,
        left8Left: 50,

        left9Width: 18,
        left9Height: 18,
        left9Top: 366,
        left9Left: 50,

        left10Width: 18,
        left10Height: 18,
        left10Top: 396,
        left10Left: 50,

        left11Width: 18,
        left11Height: 18,
        left11Top: 424,
        left11Left: 50,

        left12Width: 18,
        left12Height: 18,
        left12Top: 453,
        left12Left: 50,

        left13Width: 18,
        left13Height: 18,
        left13Top: 481,
        left13Left: 50,

        left14Width: 18,
        left14Height: 18,
        left14Top: 510,
        left14Left: 51,

        right1Width: 18,
        right1Height: 18,
        right1Top: 133,
        right1Left: 408,

        right2Width: 18,
        right2Height: 18,
        right2Top: 161,
        right2Left: 408,

        right3Width: 18,
        right3Height: 18,
        right3Top: 190,
        right3Left: 408,

        right4Width: 18,
        right4Height: 18,
        right4Top: 220,
        right4Left: 407,

        right5Width: 18,
        right5Height: 18,
        right5Top: 249,
        right5Left: 408,

        right6Width: 18,
        right6Height: 18,
        right6Top: 278,
        right6Left: 408,

        right7Width: 18,
        right7Height: 18,
        right7Top: 306,
        right7Left: 408,

        right8Width: 18,
        right8Height: 18,
        right8Top: 334,
        right8Left: 405,

        right9Width: 34,
        right9Height: 18,
        right9Top: 365,
        right9Left: 400,

        right10Width: 34,
        right10Height: 18,
        right10Top: 394,
        right10Left: 400,

        right11Width: 34,
        right11Height: 18,
        right11Top: 423,
        right11Left: 400,

        right12Width: 34,
        right12Height: 18,
        right12Top: 453,
        right12Left: 400,

        right13Width: 18,
        right13Height: 18,
        right13Top: 483,
        right13Left: 407,

        right14Width: 18,
        right14Height: 18,
        right14Top: 513,
        right14Left: 408,
      },
      id: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 181,
        headerTop: 36,

        wordwrap: 'normal',
        lineHeight: 0,
        letterspacing: 0,
        textResize: 11,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 18,
        left3Height: 18,
        left3Top: 190,
        left3Left: 53,

        left4Width: 18,
        left4Height: 18,
        left4Top: 218,
        left4Left: 53,

        left5Width: 18,
        left5Height: 18,
        left5Top: 247,
        left5Left: 53,

        left6Width: 18,
        left6Height: 18,
        left6Top: 276,
        left6Left: 53,

        left7Width: 18,
        left7Height: 18,
        left7Top: 304,
        left7Left: 53,

        left8Width: 18,
        left8Height: 18,
        left8Top: 336,
        left8Left: 53,

        left9Width: 18,
        left9Height: 18,
        left9Top: 366,
        left9Left: 53,

        left10Width: 18,
        left10Height: 18,
        left10Top: 395,
        left10Left: 53,

        left11Width: 18,
        left11Height: 18,
        left11Top: 424,
        left11Left: 53,

        left12Width: 18,
        left12Height: 18,
        left12Top: 452,
        left12Left: 53,

        left13Width: 18,
        left13Height: 18,
        left13Top: 482,
        left13Left: 53,

        left14Width: 18,
        left14Height: 18,
        left14Top: 511,
        left14Left: 53,

        right1Width: 18,
        right1Height: 18,
        right1Top: 132,
        right1Left: 407,

        right2Width: 18,
        right2Height: 18,
        right2Top: 161,
        right2Left: 407,

        right3Width: 18,
        right3Height: 18,
        right3Top: 190,
        right3Left: 407,

        right4Width: 18,
        right4Height: 18,
        right4Top: 218,
        right4Left: 407,

        right5Width: 18,
        right5Height: 18,
        right5Top: 248,
        right5Left: 407,

        right6Width: 18,
        right6Height: 18,
        right6Top: 277,
        right6Left: 407,

        right7Width: 18,
        right7Height: 18,
        right7Top: 306,
        right7Left: 407,

        right8Width: 28,
        right8Height: 18,
        right8Top: 334,
        right8Left: 402,

        right9Width: 35,
        right9Height: 18,
        right9Top: 371,
        right9Left: 399,

        right10Width: 35,
        right10Height: 18,
        right10Top: 400,
        right10Left: 399,

        right11Width: 35,
        right11Height: 18,
        right11Top: 429,
        right11Left: 399,

        right12Width: 35,
        right12Height: 18,
        right12Top: 460,
        right12Left: 399,

        right13Width: 18,
        right13Height: 18,
        right13Top: 483,
        right13Left: 407,

        right14Width: 18,
        right14Height: 18,
        right14Top: 511,
        right14Left: 407,
      },
      it: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 124,
        headerTop: 37,

        wordwrap: 'break-word',
        lineHeight: 8,
        letterspacing: -0.1,
        textResize: 12,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 18,
        left3Height: 18,
        left3Top: 190,
        left3Left: 53,

        left4Width: 18,
        left4Height: 18,
        left4Top: 219,
        left4Left: 53,

        left5Width: 18,
        left5Height: 18,
        left5Top: 247,
        left5Left: 53,

        left6Width: 18,
        left6Height: 18,
        left6Top: 276,
        left6Left: 53,

        left7Width: 18,
        left7Height: 18,
        left7Top: 305,
        left7Left: 53,

        left8Width: 18,
        left8Height: 18,
        left8Top: 338,
        left8Left: 53,

        left9Width: 18,
        left9Height: 18,
        left9Top: 366,
        left9Left: 53,

        left10Width: 18,
        left10Height: 18,
        left10Top: 394,
        left10Left: 53,

        left11Width: 18,
        left11Height: 18,
        left11Top: 424,
        left11Left: 53,

        left12Width: 18,
        left12Height: 18,
        left12Top: 454,
        left12Left: 53,

        left13Width: 18,
        left13Height: 18,
        left13Top: 482,
        left13Left: 53,

        left14Width: 18,
        left14Height: 18,
        left14Top: 511,
        left14Left: 53,

        right1Width: 18,
        right1Height: 18,
        right1Top: 131,
        right1Left: 407,

        right2Width: 18,
        right2Height: 18,
        right2Top: 161,
        right2Left: 407,

        right3Width: 18,
        right3Height: 18,
        right3Top: 190,
        right3Left: 407,

        right4Width: 18,
        right4Height: 18,
        right4Top: 218,
        right4Left: 407,

        right5Width: 18,
        right5Height: 18,
        right5Top: 248,
        right5Left: 407,

        right6Width: 18,
        right6Height: 18,
        right6Top: 277,
        right6Left: 407,

        right7Width: 18,
        right7Height: 18,
        right7Top: 305,
        right7Left: 407,

        right8Width: 18,
        right8Height: 18,
        right8Top: 333,
        right8Left: 405,

        right9Width: 33,
        right9Height: 18,
        right9Top: 365,
        right9Left: 400,

        right10Width: 33,
        right10Height: 18,
        right10Top: 394,
        right10Left: 400,

        right11Width: 33,
        right11Height: 18,
        right11Top: 424,
        right11Left: 400,

        right12Width: 33,
        right12Height: 18,
        right12Top: 455,
        right12Left: 400,

        right13Width: 18,
        right13Height: 18,
        right13Top: 482,
        right13Left: 407,

        right14Width: 18,
        right14Height: 18,
        right14Top: 511,
        right14Left: 407,
      },
      ja: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 156,
        headerTop: 38,

        wordwrap: 'normal',
        lineHeight: 0,
        letterspacing: 0,
        textResize: 11,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 18,
        left3Height: 18,
        left3Top: 190,
        left3Left: 61,

        left4Width: 18,
        left4Height: 18,
        left4Top: 219,
        left4Left: 61,

        left5Width: 18,
        left5Height: 18,
        left5Top: 248,
        left5Left: 61,

        left6Width: 18,
        left6Height: 18,
        left6Top: 277,
        left6Left: 61,

        left7Width: 18,
        left7Height: 18,
        left7Top: 306,
        left7Left: 61,

        left8Width: 18,
        left8Height: 18,
        left8Top: 336,
        left8Left: 61,

        left9Width: 18,
        left9Height: 18,
        left9Top: 365,
        left9Left: 61,

        left10Width: 18,
        left10Height: 18,
        left10Top: 394,
        left10Left: 61,

        left11Width: 18,
        left11Height: 18,
        left11Top: 423,
        left11Left: 61,

        left12Width: 18,
        left12Height: 18,
        left12Top: 453,
        left12Left: 61,

        left13Width: 18,
        left13Height: 18,
        left13Top: 483,
        left13Left: 61,

        left14Width: 18,
        left14Height: 18,
        left14Top: 511,
        left14Left: 61,

        right1Width: 18,
        right1Height: 18,
        right1Top: 132,
        right1Left: 408,

        right2Width: 18,
        right2Height: 18,
        right2Top: 161,
        right2Left: 408,

        right3Width: 18,
        right3Height: 18,
        right3Top: 190,
        right3Left: 408,

        right4Width: 18,
        right4Height: 18,
        right4Top: 219,
        right4Left: 408,

        right5Width: 18,
        right5Height: 18,
        right5Top: 248,
        right5Left: 408,

        right6Width: 18,
        right6Height: 18,
        right6Top: 277,
        right6Left: 408,

        right7Width: 18,
        right7Height: 18,
        right7Top: 306,
        right7Left: 408,

        right8Width: 28,
        right8Height: 18,
        right8Top: 334,
        right8Left: 402,

        right9Width: 35,
        right9Height: 18,
        right9Top: 374,
        right9Left: 399,

        right10Width: 35,
        right10Height: 18,
        right10Top: 403,
        right10Left: 399,

        right11Width: 35,
        right11Height: 18,
        right11Top: 432,
        right11Left: 399,

        right12Width: 35,
        right12Height: 18,
        right12Top: 462,
        right12Left: 399,

        right13Width: 18,
        right13Height: 18,
        right13Top: 483,
        right13Left: 407,

        right14Width: 18,
        right14Height: 18,
        right14Top: 513,
        right14Left: 408,
      },
      kh: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 222,
        headerTop: 40,

        wordwrap: 'normal',
        lineHeight: 8,
        letterspacing: 0,
        textResize: 10,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 18,
        left3Height: 18,
        left3Top: 191,
        left3Left: 50,

        left4Width: 18,
        left4Height: 18,
        left4Top: 220,
        left4Left: 51,

        left5Width: 18,
        left5Height: 18,
        left5Top: 249,
        left5Left: 51,

        left6Width: 18,
        left6Height: 18,
        left6Top: 278,
        left6Left: 50,

        left7Width: 18,
        left7Height: 18,
        left7Top: 307,
        left7Left: 50,

        left8Width: 18,
        left8Height: 18,
        left8Top: 337,
        left8Left: 51,

        left9Width: 18,
        left9Height: 18,
        left9Top: 366,
        left9Left: 51,

        left10Width: 18,
        left10Height: 18,
        left10Top: 394,
        left10Left: 51,

        left11Width: 18,
        left11Height: 18,
        left11Top: 423,
        left11Left: 51,

        left12Width: 18,
        left12Height: 18,
        left12Top: 453,
        left12Left: 51,

        left13Width: 18,
        left13Height: 18,
        left13Top: 481,
        left13Left: 51,

        left14Width: 18,
        left14Height: 18,
        left14Top: 511,
        left14Left: 51,

        right1Width: 18,
        right1Height: 18,
        right1Top: 132,
        right1Left: 408,

        right2Width: 18,
        right2Height: 18,
        right2Top: 162,
        right2Left: 408,

        right3Width: 18,
        right3Height: 18,
        right3Top: 190,
        right3Left: 407,

        right4Width: 18,
        right4Height: 18,
        right4Top: 219,
        right4Left: 408,

        right5Width: 18,
        right5Height: 18,
        right5Top: 249,
        right5Left: 407,

        right6Width: 18,
        right6Height: 18,
        right6Top: 278,
        right6Left: 408,

        right7Width: 18,
        right7Height: 18,
        right7Top: 307,
        right7Left: 408,

        right8Width: 18,
        right8Height: 18,
        right8Top: 334,
        right8Left: 405,

        right9Width: 32,
        right9Height: 24,
        right9Top: 365,
        right9Left: 400,

        right10Width: 32,
        right10Height: 24,
        right10Top: 393,
        right10Left: 400,

        right11Width: 32,
        right11Height: 24,
        right11Top: 423,
        right11Left: 400,

        right12Width: 32,
        right12Height: 24,
        right12Top: 454,
        right12Left: 400,

        right13Width: 18,
        right13Height: 18,
        right13Top: 483,
        right13Left: 408,

        right14Width: 18,
        right14Height: 18,
        right14Top: 513,
        right14Left: 408,
      },
      ko: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 220,
        headerTop: 38,

        wordwrap: 'normal',
        lineHeight: 9,
        letterspacing: 0,
        textResize: 9,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 18,
        left3Height: 18,
        left3Top: 191,
        left3Left: 80,

        left4Width: 18,
        left4Height: 18,
        left4Top: 220,
        left4Left: 80,

        left5Width: 18,
        left5Height: 18,
        left5Top: 249,
        left5Left: 80,

        left6Width: 18,
        left6Height: 18,
        left6Top: 278,
        left6Left: 80,

        left7Width: 18,
        left7Height: 18,
        left7Top: 307,
        left7Left: 80,

        left8Width: 18,
        left8Height: 18,
        left8Top: 336,
        left8Left: 80,

        left9Width: 18,
        left9Height: 18,
        left9Top: 367,
        left9Left: 80,

        left10Width: 18,
        left10Height: 18,
        left10Top: 395,
        left10Left: 80,

        left11Width: 18,
        left11Height: 18,
        left11Top: 424,
        left11Left: 80,

        left12Width: 18,
        left12Height: 18,
        left12Top: 454,
        left12Left: 80,

        left13Width: 18,
        left13Height: 18,
        left13Top: 484,
        left13Left: 79,

        left14Width: 18,
        left14Height: 18,
        left14Top: 511,
        left14Left: 79,

        right1Width: 18,
        right1Height: 18,
        right1Top: 132,
        right1Left: 407,

        right2Width: 18,
        right2Height: 18,
        right2Top: 162,
        right2Left: 407,

        right3Width: 18,
        right3Height: 18,
        right3Top: 190,
        right3Left: 407,

        right4Width: 18,
        right4Height: 18,
        right4Top: 219,
        right4Left: 407,

        right5Width: 18,
        right5Height: 18,
        right5Top: 248,
        right5Left: 407,

        right6Width: 18,
        right6Height: 18,
        right6Top: 277,
        right6Left: 407,

        right7Width: 18,
        right7Height: 18,
        right7Top: 306,
        right7Left: 407,

        right8Width: 28,
        right8Height: 18,
        right8Top: 334,
        right8Left: 402,

        right9Width: 35,
        right9Height: 18,
        right9Top: 366,
        right9Left: 399,

        right10Width: 35,
        right10Height: 18,
        right10Top: 395,
        right10Left: 399,

        right11Width: 35,
        right11Height: 18,
        right11Top: 424,
        right11Left: 399,

        right12Width: 35,
        right12Height: 18,
        right12Top: 454,
        right12Left: 399,

        right13Width: 18,
        right13Height: 18,
        right13Top: 485,
        right13Left: 407,

        right14Width: 18,
        right14Height: 18,
        right14Top: 512,
        right14Left: 407,
      },
      lt: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 133,
        headerTop: 38,

        wordwrap: 'normal',
        lineHeight: 0,
        letterspacing: 0,
        textResize: 11,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 18,
        left3Height: 18,
        left3Top: 187,
        left3Left: 53,

        left4Width: 18,
        left4Height: 18,
        left4Top: 219,
        left4Left: 53,

        left5Width: 18,
        left5Height: 18,
        left5Top: 246,
        left5Left: 53,

        left6Width: 18,
        left6Height: 18,
        left6Top: 276,
        left6Left: 53,

        left7Width: 18,
        left7Height: 18,
        left7Top: 303,
        left7Left: 53,

        left8Width: 18,
        left8Height: 18,
        left8Top: 336,
        left8Left: 53,

        left9Width: 18,
        left9Height: 18,
        left9Top: 364,
        left9Left: 53,

        left10Width: 18,
        left10Height: 18,
        left10Top: 395,
        left10Left: 53,

        left11Width: 18,
        left11Height: 18,
        left11Top: 424,
        left11Left: 53,

        left12Width: 18,
        left12Height: 18,
        left12Top: 453,
        left12Left: 53,

        left13Width: 18,
        left13Height: 18,
        left13Top: 482,
        left13Left: 53,

        left14Width: 18,
        left14Height: 18,
        left14Top: 511,
        left14Left: 53,

        right1Width: 18,
        right1Height: 18,
        right1Top: 131,
        right1Left: 408,

        right2Width: 18,
        right2Height: 18,
        right2Top: 160,
        right2Left: 408,

        right3Width: 18,
        right3Height: 18,
        right3Top: 189,
        right3Left: 408,

        right4Width: 18,
        right4Height: 18,
        right4Top: 218,
        right4Left: 407,

        right5Width: 18,
        right5Height: 18,
        right5Top: 247,
        right5Left: 407,

        right6Width: 18,
        right6Height: 18,
        right6Top: 276,
        right6Left: 407,

        right7Width: 18,
        right7Height: 18,
        right7Top: 305,
        right7Left: 407,

        right8Width: 28,
        right8Height: 18,
        right8Top: 332,
        right8Left: 402,

        right9Width: 35,
        right9Height: 18,
        right9Top: 371,
        right9Left: 399,

        right10Width: 35,
        right10Height: 18,
        right10Top: 400,
        right10Left: 399,

        right11Width: 35,
        right11Height: 18,
        right11Top: 429,
        right11Left: 399,

        right12Width: 35,
        right12Height: 18,
        right12Top: 460,
        right12Left: 399,

        right13Width: 18,
        right13Height: 18,
        right13Top: 482,
        right13Left: 407,

        right14Width: 18,
        right14Height: 18,
        right14Top: 510,
        right14Left: 407,
      },
      lv: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 158,
        headerTop: 40,

        wordwrap: 'break-word',
        lineHeight: 7,
        letterspacing: -0.05,
        textResize: 12,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 18,
        left3Height: 18,
        left3Top: 189,
        left3Left: 53,

        left4Width: 18,
        left4Height: 18,
        left4Top: 218,
        left4Left: 53,

        left5Width: 18,
        left5Height: 18,
        left5Top: 247,
        left5Left: 53,

        left6Width: 18,
        left6Height: 18,
        left6Top: 276,
        left6Left: 53,

        left7Width: 18,
        left7Height: 18,
        left7Top: 305,
        left7Left: 53,

        left8Width: 18,
        left8Height: 18,
        left8Top: 336,
        left8Left: 53,

        left9Width: 18,
        left9Height: 18,
        left9Top: 367,
        left9Left: 53,

        left10Width: 18,
        left10Height: 18,
        left10Top: 395,
        left10Left: 53,

        left11Width: 18,
        left11Height: 18,
        left11Top: 424,
        left11Left: 53,

        left12Width: 18,
        left12Height: 18,
        left12Top: 454,
        left12Left: 53,

        left13Width: 18,
        left13Height: 18,
        left13Top: 483,
        left13Left: 53,

        left14Width: 18,
        left14Height: 18,
        left14Top: 511,
        left14Left: 53,

        right1Width: 18,
        right1Height: 18,
        right1Top: 133,
        right1Left: 408,

        right2Width: 18,
        right2Height: 18,
        right2Top: 161,
        right2Left: 408,

        right3Width: 18,
        right3Height: 18,
        right3Top: 189,
        right3Left: 407,

        right4Width: 18,
        right4Height: 18,
        right4Top: 218,
        right4Left: 407,

        right5Width: 18,
        right5Height: 18,
        right5Top: 247,
        right5Left: 407,

        right6Width: 18,
        right6Height: 18,
        right6Top: 276,
        right6Left: 407,

        right7Width: 18,
        right7Height: 18,
        right7Top: 306,
        right7Left: 407,

        right8Width: 18,
        right8Height: 18,
        right8Top: 333,
        right8Left: 405,

        right9Width: 28,
        right9Height: 18,
        right9Top: 366,
        right9Left: 402,

        right10Width: 28,
        right10Height: 18,
        right10Top: 395,
        right10Left: 402,

        right11Width: 28,
        right11Height: 18,
        right11Top: 424,
        right11Left: 402,

        right12Width: 28,
        right12Height: 18,
        right12Top: 453,
        right12Left: 402,

        right13Width: 18,
        right13Height: 18,
        right13Top: 482,
        right13Left: 408,

        right14Width: 18,
        right14Height: 18,
        right14Top: 511,
        right14Left: 408,
      },
      mt: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 142,
        headerTop: 39,

        wordwrap: 'break-word',
        lineHeight: 9,
        letterspacing: 0,
        textResize: 11,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 18,
        left3Height: 18,
        left3Top: 188,
        left3Left: 53,

        left4Width: 18,
        left4Height: 18,
        left4Top: 218,
        left4Left: 53,

        left5Width: 18,
        left5Height: 18,
        left5Top: 247,
        left5Left: 53,

        left6Width: 18,
        left6Height: 18,
        left6Top: 276,
        left6Left: 53,

        left7Width: 18,
        left7Height: 18,
        left7Top: 304,
        left7Left: 53,

        left8Width: 18,
        left8Height: 18,
        left8Top: 336,
        left8Left: 53,

        left9Width: 18,
        left9Height: 18,
        left9Top: 366,
        left9Left: 53,

        left10Width: 18,
        left10Height: 18,
        left10Top: 395,
        left10Left: 53,

        left11Width: 18,
        left11Height: 18,
        left11Top: 424,
        left11Left: 53,

        left12Width: 18,
        left12Height: 18,
        left12Top: 454,
        left12Left: 53,

        left13Width: 18,
        left13Height: 18,
        left13Top: 483,
        left13Left: 53,

        left14Width: 18,
        left14Height: 18,
        left14Top: 511,
        left14Left: 53,

        right1Width: 18,
        right1Height: 18,
        right1Top: 132,
        right1Left: 408,

        right2Width: 18,
        right2Height: 18,
        right2Top: 160,
        right2Left: 408,

        right3Width: 18,
        right3Height: 18,
        right3Top: 189,
        right3Left: 408,

        right4Width: 18,
        right4Height: 18,
        right4Top: 218,
        right4Left: 407,

        right5Width: 18,
        right5Height: 18,
        right5Top: 248,
        right5Left: 407,

        right6Width: 18,
        right6Height: 18,
        right6Top: 276,
        right6Left: 407,

        right7Width: 18,
        right7Height: 18,
        right7Top: 305,
        right7Left: 407,

        right8Width: 28,
        right8Height: 18,
        right8Top: 333,
        right8Left: 402,

        right9Width: 27,
        right9Height: 18,
        right9Top: 363,
        right9Left: 404,

        right10Width: 27,
        right10Height: 18,
        right10Top: 391,
        right10Left: 404,

        right11Width: 27,
        right11Height: 18,
        right11Top: 420,
        right11Left: 404,

        right12Width: 27,
        right12Height: 18,
        right12Top: 451,
        right12Left: 404,

        right13Width: 18,
        right13Height: 18,
        right13Top: 482,
        right13Left: 407,

        right14Width: 18,
        right14Height: 18,
        right14Top: 511,
        right14Left: 407,
      },
      my: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 137,
        headerTop: 36,

        wordwrap: 'normal',
        lineHeight: 0,
        letterspacing: -0.05,
        textResize: 11,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 18,
        left3Height: 18,
        left3Top: 190,
        left3Left: 53,

        left4Width: 18,
        left4Height: 18,
        left4Top: 218,
        left4Left: 53,

        left5Width: 18,
        left5Height: 18,
        left5Top: 247,
        left5Left: 53,

        left6Width: 18,
        left6Height: 18,
        left6Top: 276,
        left6Left: 53,

        left7Width: 18,
        left7Height: 18,
        left7Top: 304,
        left7Left: 53,

        left8Width: 18,
        left8Height: 18,
        left8Top: 336,
        left8Left: 53,

        left9Width: 18,
        left9Height: 18,
        left9Top: 366,
        left9Left: 53,

        left10Width: 18,
        left10Height: 18,
        left10Top: 395,
        left10Left: 53,

        left11Width: 18,
        left11Height: 18,
        left11Top: 424,
        left11Left: 53,

        left12Width: 18,
        left12Height: 18,
        left12Top: 452,
        left12Left: 53,

        left13Width: 18,
        left13Height: 18,
        left13Top: 482,
        left13Left: 53,

        left14Width: 18,
        left14Height: 18,
        left14Top: 511,
        left14Left: 53,

        right1Width: 18,
        right1Height: 18,
        right1Top: 132,
        right1Left: 407,

        right2Width: 18,
        right2Height: 18,
        right2Top: 162,
        right2Left: 407,

        right3Width: 18,
        right3Height: 18,
        right3Top: 191,
        right3Left: 407,

        right4Width: 18,
        right4Height: 18,
        right4Top: 219,
        right4Left: 407,

        right5Width: 18,
        right5Height: 18,
        right5Top: 249,
        right5Left: 407,

        right6Width: 18,
        right6Height: 18,
        right6Top: 277,
        right6Left: 407,

        right7Width: 18,
        right7Height: 18,
        right7Top: 306,
        right7Left: 407,

        right8Width: 28,
        right8Height: 18,
        right8Top: 334,
        right8Left: 402,

        right9Width: 35,
        right9Height: 18,
        right9Top: 373,
        right9Left: 399,

        right10Width: 35,
        right10Height: 18,
        right10Top: 401,
        right10Left: 399,

        right11Width: 35,
        right11Height: 18,
        right11Top: 431,
        right11Left: 399,

        right12Width: 35,
        right12Height: 18,
        right12Top: 461,
        right12Left: 399,

        right13Width: 18,
        right13Height: 18,
        right13Top: 482,
        right13Left: 407,

        right14Width: 18,
        right14Height: 18,
        right14Top: 511,
        right14Left: 407,
      },
      nb: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 129,
        headerTop: 40,

        wordwrap: 'break-word',
        lineHeight: 8,
        letterspacing: -0.05,
        textResize: 12,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 18,
        left3Height: 18,
        left3Top: 190,
        left3Left: 53,

        left4Width: 18,
        left4Height: 18,
        left4Top: 219,
        left4Left: 53,

        left5Width: 18,
        left5Height: 18,
        left5Top: 248,
        left5Left: 53,

        left6Width: 18,
        left6Height: 18,
        left6Top: 277,
        left6Left: 53,

        left7Width: 18,
        left7Height: 18,
        left7Top: 306,
        left7Left: 53,

        left8Width: 18,
        left8Height: 18,
        left8Top: 337,
        left8Left: 53,

        left9Width: 18,
        left9Height: 18,
        left9Top: 367,
        left9Left: 53,

        left10Width: 18,
        left10Height: 18,
        left10Top: 395,
        left10Left: 53,

        left11Width: 18,
        left11Height: 18,
        left11Top: 424,
        left11Left: 53,

        left12Width: 18,
        left12Height: 18,
        left12Top: 453,
        left12Left: 53,

        left13Width: 18,
        left13Height: 18,
        left13Top: 482,
        left13Left: 53,

        left14Width: 18,
        left14Height: 18,
        left14Top: 511,
        left14Left: 53,

        right1Width: 18,
        right1Height: 18,
        right1Top: 133,
        right1Left: 408,

        right2Width: 18,
        right2Height: 18,
        right2Top: 162,
        right2Left: 408,

        right3Width: 18,
        right3Height: 18,
        right3Top: 190,
        right3Left: 408,

        right4Width: 18,
        right4Height: 18,
        right4Top: 219,
        right4Left: 408,

        right5Width: 18,
        right5Height: 18,
        right5Top: 248,
        right5Left: 407,

        right6Width: 18,
        right6Height: 18,
        right6Top: 277,
        right6Left: 407,

        right7Width: 18,
        right7Height: 18,
        right7Top: 306,
        right7Left: 408,

        right8Width: 18,
        right8Height: 18,
        right8Top: 334,
        right8Left: 405,

        right9Width: 34,
        right9Height: 18,
        right9Top: 366,
        right9Left: 400,

        right10Width: 34,
        right10Height: 18,
        right10Top: 394,
        right10Left: 400,

        right11Width: 34,
        right11Height: 18,
        right11Top: 424,
        right11Left: 400,

        right12Width: 34,
        right12Height: 18,
        right12Top: 455,
        right12Left: 400,

        right13Width: 18,
        right13Height: 18,
        right13Top: 482,
        right13Left: 408,

        right14Width: 18,
        right14Height: 18,
        right14Top: 511,
        right14Left: 408,
      },
      nl: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 150,
        headerTop: 37,

        wordwrap: 'normal',
        lineHeight: 0,
        letterspacing: -0.07,
        textResize: 11,
        symbolResize: 13,
        right4SymbolResize: 13,
        right7SymbolResize: 14,

        left3Width: 18,
        left3Height: 18,
        left3Top: 190,
        left3Left: 53,

        left4Width: 18,
        left4Height: 18,
        left4Top: 218,
        left4Left: 53,

        left5Width: 18,
        left5Height: 18,
        left5Top: 247,
        left5Left: 53,

        left6Width: 18,
        left6Height: 18,
        left6Top: 276,
        left6Left: 53,

        left7Width: 18,
        left7Height: 18,
        left7Top: 304,
        left7Left: 53,

        left8Width: 18,
        left8Height: 18,
        left8Top: 336,
        left8Left: 53,

        left9Width: 18,
        left9Height: 18,
        left9Top: 366,
        left9Left: 53,

        left10Width: 18,
        left10Height: 18,
        left10Top: 395,
        left10Left: 53,

        left11Width: 18,
        left11Height: 18,
        left11Top: 424,
        left11Left: 53,

        left12Width: 18,
        left12Height: 18,
        left12Top: 454,
        left12Left: 53,

        left13Width: 18,
        left13Height: 18,
        left13Top: 483,
        left13Left: 53,

        left14Width: 18,
        left14Height: 18,
        left14Top: 511,
        left14Left: 53,

        right1Width: 18,
        right1Height: 18,
        right1Top: 132,
        right1Left: 407,

        right2Width: 18,
        right2Height: 18,
        right2Top: 161,
        right2Left: 407,

        right3Width: 18,
        right3Height: 18,
        right3Top: 190,
        right3Left: 407,

        right4Width: 18,
        right4Height: 18,
        right4Top: 218,
        right4Left: 407,

        right5Width: 18,
        right5Height: 18,
        right5Top: 248,
        right5Left: 407,

        right6Width: 18,
        right6Height: 18,
        right6Top: 277,
        right6Left: 407,

        right7Width: 18,
        right7Height: 18,
        right7Top: 306,
        right7Left: 407,

        right8Width: 28,
        right8Height: 18,
        right8Top: 333,
        right8Left: 402,

        right9Width: 35,
        right9Height: 18,
        right9Top: 371,
        right9Left: 399,

        right10Width: 35,
        right10Height: 18,
        right10Top: 400,
        right10Left: 399,

        right11Width: 35,
        right11Height: 18,
        right11Top: 429,
        right11Left: 399,

        right12Width: 35,
        right12Height: 18,
        right12Top: 460,
        right12Left: 399,

        right13Width: 18,
        right13Height: 18,
        right13Top: 483,
        right13Left: 407,

        right14Width: 18,
        right14Height: 18,
        right14Top: 511,
        right14Left: 407,
      },
      ph: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 135,
        headerTop: 38,

        wordwrap: 'normal',
        lineHeight: 0,
        letterspacing: -0.15,
        textResize: 11,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 18,
        left3Height: 18,
        left3Top: 190,
        left3Left: 53,

        left4Width: 18,
        left4Height: 18,
        left4Top: 218,
        left4Left: 53,

        left5Width: 18,
        left5Height: 18,
        left5Top: 247,
        left5Left: 53,

        left6Width: 18,
        left6Height: 18,
        left6Top: 276,
        left6Left: 53,

        left7Width: 18,
        left7Height: 18,
        left7Top: 304,
        left7Left: 53,

        left8Width: 18,
        left8Height: 18,
        left8Top: 336,
        left8Left: 53,

        left9Width: 18,
        left9Height: 18,
        left9Top: 366,
        left9Left: 53,

        left10Width: 18,
        left10Height: 18,
        left10Top: 395,
        left10Left: 53,

        left11Width: 18,
        left11Height: 18,
        left11Top: 424,
        left11Left: 53,

        left12Width: 18,
        left12Height: 18,
        left12Top: 454,
        left12Left: 53,

        left13Width: 18,
        left13Height: 18,
        left13Top: 482,
        left13Left: 53,

        left14Width: 18,
        left14Height: 18,
        left14Top: 510,
        left14Left: 53,

        right1Width: 18,
        right1Height: 18,
        right1Top: 133,
        right1Left: 407,

        right2Width: 18,
        right2Height: 18,
        right2Top: 161,
        right2Left: 407,

        right3Width: 18,
        right3Height: 18,
        right3Top: 190,
        right3Left: 407,

        right4Width: 18,
        right4Height: 18,
        right4Top: 218,
        right4Left: 407,

        right5Width: 18,
        right5Height: 18,
        right5Top: 248,
        right5Left: 407,

        right6Width: 18,
        right6Height: 18,
        right6Top: 277,
        right6Left: 407,

        right7Width: 18,
        right7Height: 18,
        right7Top: 306,
        right7Left: 407,

        right8Width: 28,
        right8Height: 18,
        right8Top: 334,
        right8Left: 402,

        right9Width: 35,
        right9Height: 18,
        right9Top: 372,
        right9Left: 399,

        right10Width: 35,
        right10Height: 18,
        right10Top: 401,
        right10Left: 399,

        right11Width: 35,
        right11Height: 18,
        right11Top: 432,
        right11Left: 399,

        right12Width: 35,
        right12Height: 18,
        right12Top: 462,
        right12Left: 399,

        right13Width: 18,
        right13Height: 18,
        right13Top: 481,
        right13Left: 407,

        right14Width: 18,
        right14Height: 18,
        right14Top: 510,
        right14Left: 407,
      },
      pl: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 124,
        headerTop: 37,

        wordwrap: 'normal',
        lineHeight: 0,
        letterspacing: -0.05,
        textResize: 11,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 18,
        left3Height: 18,
        left3Top: 190,
        left3Left: 53,

        left4Width: 18,
        left4Height: 18,
        left4Top: 218,
        left4Left: 53,

        left5Width: 18,
        left5Height: 18,
        left5Top: 247,
        left5Left: 53,

        left6Width: 18,
        left6Height: 18,
        left6Top: 276,
        left6Left: 53,

        left7Width: 18,
        left7Height: 18,
        left7Top: 304,
        left7Left: 53,

        left8Width: 18,
        left8Height: 18,
        left8Top: 336,
        left8Left: 53,

        left9Width: 18,
        left9Height: 18,
        left9Top: 366,
        left9Left: 53,

        left10Width: 18,
        left10Height: 18,
        left10Top: 395,
        left10Left: 53,

        left11Width: 18,
        left11Height: 18,
        left11Top: 424,
        left11Left: 53,

        left12Width: 18,
        left12Height: 18,
        left12Top: 454,
        left12Left: 53,

        left13Width: 18,
        left13Height: 18,
        left13Top: 483,
        left13Left: 53,

        left14Width: 18,
        left14Height: 18,
        left14Top: 511,
        left14Left: 53,

        right1Width: 18,
        right1Height: 18,
        right1Top: 132,
        right1Left: 407,

        right2Width: 18,
        right2Height: 18,
        right2Top: 162,
        right2Left: 407,

        right3Width: 18,
        right3Height: 18,
        right3Top: 191,
        right3Left: 407,

        right4Width: 18,
        right4Height: 18,
        right4Top: 219,
        right4Left: 407,

        right5Width: 18,
        right5Height: 18,
        right5Top: 249,
        right5Left: 407,

        right6Width: 18,
        right6Height: 18,
        right6Top: 277,
        right6Left: 407,

        right7Width: 18,
        right7Height: 18,
        right7Top: 306,
        right7Left: 407,

        right8Width: 28,
        right8Height: 18,
        right8Top: 334,
        right8Left: 402,

        right9Width: 35,
        right9Height: 18,
        right9Top: 373,
        right9Left: 399,

        right10Width: 35,
        right10Height: 18,
        right10Top: 402,
        right10Left: 399,

        right11Width: 35,
        right11Height: 18,
        right11Top: 431,
        right11Left: 399,

        right12Width: 35,
        right12Height: 18,
        right12Top: 462,
        right12Left: 399,

        right13Width: 18,
        right13Height: 18,
        right13Top: 482,
        right13Left: 407,

        right14Width: 18,
        right14Height: 18,
        right14Top: 511,
        right14Left: 407,
      },
      'pt-BR': {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 125,
        headerTop: 40,

        wordwrap: 'normal',
        lineHeight: 0,
        letterspacing: -0.05,
        textResize: 11,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 18,
        left3Height: 18,
        left3Top: 190,
        left3Left: 53,

        left4Width: 18,
        left4Height: 18,
        left4Top: 218,
        left4Left: 53,

        left5Width: 18,
        left5Height: 18,
        left5Top: 247,
        left5Left: 53,

        left6Width: 18,
        left6Height: 18,
        left6Top: 276,
        left6Left: 53,

        left7Width: 18,
        left7Height: 18,
        left7Top: 306,
        left7Left: 53,

        left8Width: 18,
        left8Height: 18,
        left8Top: 336,
        left8Left: 53,

        left9Width: 18,
        left9Height: 18,
        left9Top: 366,
        left9Left: 53,

        left10Width: 18,
        left10Height: 18,
        left10Top: 395,
        left10Left: 53,

        left11Width: 18,
        left11Height: 18,
        left11Top: 424,
        left11Left: 53,

        left12Width: 18,
        left12Height: 18,
        left12Top: 454,
        left12Left: 53,

        left13Width: 18,
        left13Height: 18,
        left13Top: 483,
        left13Left: 53,

        left14Width: 18,
        left14Height: 18,
        left14Top: 511,
        left14Left: 53,

        right1Width: 18,
        right1Height: 18,
        right1Top: 132,
        right1Left: 408,

        right2Width: 18,
        right2Height: 18,
        right2Top: 161,
        right2Left: 408,

        right3Width: 18,
        right3Height: 18,
        right3Top: 190,
        right3Left: 407,

        right4Width: 18,
        right4Height: 18,
        right4Top: 218,
        right4Left: 407,

        right5Width: 18,
        right5Height: 18,
        right5Top: 248,
        right5Left: 407,

        right6Width: 18,
        right6Height: 18,
        right6Top: 277,
        right6Left: 407,

        right7Width: 18,
        right7Height: 18,
        right7Top: 306,
        right7Left: 407,

        right8Width: 28,
        right8Height: 18,
        right8Top: 334,
        right8Left: 402,

        right9Width: 35,
        right9Height: 18,
        right9Top: 373,
        right9Left: 399,

        right10Width: 35,
        right10Height: 18,
        right10Top: 401,
        right10Left: 399,

        right11Width: 35,
        right11Height: 18,
        right11Top: 431,
        right11Left: 399,

        right12Width: 35,
        right12Height: 18,
        right12Top: 462,
        right12Left: 399,

        right13Width: 18,
        right13Height: 18,
        right13Top: 482,
        right13Left: 407,

        right14Width: 18,
        right14Height: 18,
        right14Top: 511,
        right14Left: 407,
      },
      ro: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 172,
        headerTop: 40,

        wordwrap: 'normal',
        lineHeight: 0,
        letterspacing: -0.07,
        textResize: 11,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 18,
        left3Height: 18,
        left3Top: 190,
        left3Left: 53,

        left4Width: 18,
        left4Height: 18,
        left4Top: 220,
        left4Left: 53,

        left5Width: 18,
        left5Height: 18,
        left5Top: 248,
        left5Left: 53,

        left6Width: 18,
        left6Height: 18,
        left6Top: 278,
        left6Left: 53,

        left7Width: 18,
        left7Height: 18,
        left7Top: 307,
        left7Left: 53,

        left8Width: 18,
        left8Height: 18,
        left8Top: 338,
        left8Left: 53,

        left9Width: 18,
        left9Height: 18,
        left9Top: 367,
        left9Left: 53,

        left10Width: 18,
        left10Height: 18,
        left10Top: 396,
        left10Left: 53,

        left11Width: 18,
        left11Height: 18,
        left11Top: 425,
        left11Left: 53,

        left12Width: 18,
        left12Height: 18,
        left12Top: 454,
        left12Left: 53,

        left13Width: 18,
        left13Height: 18,
        left13Top: 483,
        left13Left: 53,

        left14Width: 18,
        left14Height: 18,
        left14Top: 511,
        left14Left: 53,

        right1Width: 18,
        right1Height: 18,
        right1Top: 133,
        right1Left: 408,

        right2Width: 18,
        right2Height: 18,
        right2Top: 162,
        right2Left: 408,

        right3Width: 18,
        right3Height: 18,
        right3Top: 191,
        right3Left: 407,

        right4Width: 18,
        right4Height: 18,
        right4Top: 220,
        right4Left: 407,

        right5Width: 18,
        right5Height: 18,
        right5Top: 250,
        right5Left: 407,

        right6Width: 18,
        right6Height: 18,
        right6Top: 278,
        right6Left: 407,

        right7Width: 18,
        right7Height: 18,
        right7Top: 307,
        right7Left: 407,

        right8Width: 28,
        right8Height: 18,
        right8Top: 335,
        right8Left: 402,

        right9Width: 35,
        right9Height: 18,
        right9Top: 373,
        right9Left: 399,

        right10Width: 35,
        right10Height: 18,
        right10Top: 402,
        right10Left: 399,

        right11Width: 35,
        right11Height: 18,
        right11Top: 431,
        right11Left: 399,

        right12Width: 35,
        right12Height: 18,
        right12Top: 462,
        right12Left: 399,

        right13Width: 18,
        right13Height: 18,
        right13Top: 483,
        right13Left: 407,

        right14Width: 18,
        right14Height: 18,
        right14Top: 511,
        right14Left: 407,
      },
      ru: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 147,
        headerTop: 39,

        wordwrap: 'normal',
        lineHeight: 0,
        letterspacing: -0.1,
        textResize: 11,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 18,
        left3Height: 18,
        left3Top: 190,
        left3Left: 51,

        left4Width: 18,
        left4Height: 18,
        left4Top: 219,
        left4Left: 51,

        left5Width: 18,
        left5Height: 18,
        left5Top: 248,
        left5Left: 51,

        left6Width: 18,
        left6Height: 18,
        left6Top: 277,
        left6Left: 51,

        left7Width: 18,
        left7Height: 18,
        left7Top: 306,
        left7Left: 51,

        left8Width: 18,
        left8Height: 18,
        left8Top: 335,
        left8Left: 51,

        left9Width: 18,
        left9Height: 18,
        left9Top: 365,
        left9Left: 52,

        left10Width: 18,
        left10Height: 18,
        left10Top: 394,
        left10Left: 51,

        left11Width: 18,
        left11Height: 18,
        left11Top: 424,
        left11Left: 51,

        left12Width: 18,
        left12Height: 18,
        left12Top: 453,
        left12Left: 51,

        left13Width: 18,
        left13Height: 18,
        left13Top: 482,
        left13Left: 51,

        left14Width: 18,
        left14Height: 18,
        left14Top: 511,
        left14Left: 51,

        right1Width: 18,
        right1Height: 18,
        right1Top: 132,
        right1Left: 408,

        right2Width: 18,
        right2Height: 18,
        right2Top: 162,
        right2Left: 408,

        right3Width: 18,
        right3Height: 18,
        right3Top: 190,
        right3Left: 408,

        right4Width: 18,
        right4Height: 18,
        right4Top: 219,
        right4Left: 408,

        right5Width: 18,
        right5Height: 18,
        right5Top: 248,
        right5Left: 408,

        right6Width: 18,
        right6Height: 18,
        right6Top: 277,
        right6Left: 408,

        right7Width: 18,
        right7Height: 18,
        right7Top: 306,
        right7Left: 408,

        right8Width: 38,
        right8Height: 18,
        right8Top: 334,
        right8Left: 398,

        right9Width: 38,
        right9Height: 18,
        right9Top: 373,
        right9Left: 398,

        right10Width: 38,
        right10Height: 18,
        right10Top: 401,
        right10Left: 398,

        right11Width: 38,
        right11Height: 18,
        right11Top: 431,
        right11Left: 398,

        right12Width: 38,
        right12Height: 18,
        right12Top: 461,
        right12Left: 398,

        right13Width: 18,
        right13Height: 18,
        right13Top: 484,
        right13Left: 408,

        right14Width: 18,
        right14Height: 18,
        right14Top: 513,
        right14Left: 408,
      },
      si: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 127,
        headerTop: 37,

        wordwrap: 'break-word',
        lineHeight: 8,
        letterspacing: -0.1,
        textResize: 12,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 18,
        left3Height: 18,
        left3Top: 191,
        left3Left: 53,

        left4Width: 18,
        left4Height: 18,
        left4Top: 220,
        left4Left: 53,

        left5Width: 18,
        left5Height: 18,
        left5Top: 248,
        left5Left: 53,

        left6Width: 18,
        left6Height: 18,
        left6Top: 278,
        left6Left: 53,

        left7Width: 18,
        left7Height: 18,
        left7Top: 307,
        left7Left: 53,

        left8Width: 18,
        left8Height: 18,
        left8Top: 338,
        left8Left: 53,

        left9Width: 18,
        left9Height: 18,
        left9Top: 367,
        left9Left: 53,

        left10Width: 18,
        left10Height: 18,
        left10Top: 396,
        left10Left: 53,

        left11Width: 18,
        left11Height: 18,
        left11Top: 424,
        left11Left: 53,

        left12Width: 18,
        left12Height: 18,
        left12Top: 453,
        left12Left: 53,

        left13Width: 18,
        left13Height: 18,
        left13Top: 483,
        left13Left: 53,

        left14Width: 18,
        left14Height: 18,
        left14Top: 511,
        left14Left: 53,

        right1Width: 18,
        right1Height: 18,
        right1Top: 133,
        right1Left: 407,

        right2Width: 18,
        right2Height: 18,
        right2Top: 162,
        right2Left: 408,

        right3Width: 18,
        right3Height: 18,
        right3Top: 190,
        right3Left: 407,

        right4Width: 18,
        right4Height: 18,
        right4Top: 219,
        right4Left: 407,

        right5Width: 18,
        right5Height: 18,
        right5Top: 249,
        right5Left: 407,

        right6Width: 18,
        right6Height: 18,
        right6Top: 278,
        right6Left: 407,

        right7Width: 18,
        right7Height: 18,
        right7Top: 307,
        right7Left: 407,

        right8Width: 18,
        right8Height: 18,
        right8Top: 334,
        right8Left: 405,

        right9Width: 32,
        right9Height: 18,
        right9Top: 367,
        right9Left: 400,

        right10Width: 32,
        right10Height: 18,
        right10Top: 395,
        right10Left: 400,

        right11Width: 32,
        right11Height: 18,
        right11Top: 425,
        right11Left: 400,

        right12Width: 33,
        right12Height: 18,
        right12Top: 455,
        right12Left: 400,

        right13Width: 18,
        right13Height: 18,
        right13Top: 482,
        right13Left: 408,

        right14Width: 18,
        right14Height: 18,
        right14Top: 511,
        right14Left: 408,
      },
      sk: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 132,
        headerTop: 39,

        wordwrap: 'break-word',
        lineHeight: 8,
        letterspacing: -0.1,
        textResize: 12,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 18,
        left3Height: 18,
        left3Top: 191,
        left3Left: 53,

        left4Width: 18,
        left4Height: 18,
        left4Top: 220,
        left4Left: 53,

        left5Width: 18,
        left5Height: 18,
        left5Top: 249,
        left5Left: 53,

        left6Width: 18,
        left6Height: 18,
        left6Top: 279,
        left6Left: 53,

        left7Width: 18,
        left7Height: 18,
        left7Top: 307,
        left7Left: 53,

        left8Width: 18,
        left8Height: 18,
        left8Top: 339,
        left8Left: 53,

        left9Width: 18,
        left9Height: 18,
        left9Top: 367,
        left9Left: 53,

        left10Width: 18,
        left10Height: 18,
        left10Top: 396,
        left10Left: 53,

        left11Width: 18,
        left11Height: 18,
        left11Top: 424,
        left11Left: 53,

        left12Width: 18,
        left12Height: 18,
        left12Top: 454,
        left12Left: 53,

        left13Width: 18,
        left13Height: 18,
        left13Top: 483,
        left13Left: 53,

        left14Width: 18,
        left14Height: 18,
        left14Top: 511,
        left14Left: 53,

        right1Width: 18,
        right1Height: 18,
        right1Top: 133,
        right1Left: 408,

        right2Width: 18,
        right2Height: 18,
        right2Top: 163,
        right2Left: 408,

        right3Width: 18,
        right3Height: 18,
        right3Top: 191,
        right3Left: 408,

        right4Width: 18,
        right4Height: 18,
        right4Top: 220,
        right4Left: 408,

        right5Width: 18,
        right5Height: 18,
        right5Top: 249,
        right5Left: 408,

        right6Width: 18,
        right6Height: 18,
        right6Top: 279,
        right6Left: 407,

        right7Width: 18,
        right7Height: 18,
        right7Top: 308,
        right7Left: 408,

        right8Width: 18,
        right8Height: 18,
        right8Top: 335,
        right8Left: 405,

        right9Width: 33,
        right9Height: 18,
        right9Top: 367,
        right9Left: 400,

        right10Width: 33,
        right10Height: 18,
        right10Top: 396,
        right10Left: 400,

        right11Width: 33,
        right11Height: 18,
        right11Top: 425,
        right11Left: 400,

        right12Width: 33,
        right12Height: 18,
        right12Top: 456,
        right12Left: 400,

        right13Width: 18,
        right13Height: 18,
        right13Top: 483,
        right13Left: 408,

        right14Width: 18,
        right14Height: 18,
        right14Top: 511,
        right14Left: 408,
      },
      'sr-RS': {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 179,
        headerTop: 39,

        wordwrap: 'normal',
        lineHeight: 0,
        letterspacing: -0.1,
        textResize: 11,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 18,
        left3Height: 18,
        left3Top: 190,
        left3Left: 51,

        left4Width: 18,
        left4Height: 18,
        left4Top: 219,
        left4Left: 51,

        left5Width: 18,
        left5Height: 18,
        left5Top: 248,
        left5Left: 51,

        left6Width: 18,
        left6Height: 18,
        left6Top: 278,
        left6Left: 51,

        left7Width: 18,
        left7Height: 18,
        left7Top: 305,
        left7Left: 51,

        left8Width: 18,
        left8Height: 18,
        left8Top: 336,
        left8Left: 51,

        left9Width: 18,
        left9Height: 18,
        left9Top: 365,
        left9Left: 51,

        left10Width: 18,
        left10Height: 18,
        left10Top: 395,
        left10Left: 51,

        left11Width: 18,
        left11Height: 18,
        left11Top: 424,
        left11Left: 51,

        left12Width: 18,
        left12Height: 18,
        left12Top: 453,
        left12Left: 51,

        left13Width: 18,
        left13Height: 18,
        left13Top: 482,
        left13Left: 51,

        left14Width: 18,
        left14Height: 18,
        left14Top: 511,
        left14Left: 51,

        right1Width: 18,
        right1Height: 18,
        right1Top: 132,
        right1Left: 407,

        right2Width: 18,
        right2Height: 18,
        right2Top: 161,
        right2Left: 408,

        right3Width: 18,
        right3Height: 18,
        right3Top: 190,
        right3Left: 408,

        right4Width: 18,
        right4Height: 18,
        right4Top: 218,
        right4Left: 408,

        right5Width: 18,
        right5Height: 18,
        right5Top: 248,
        right5Left: 408,

        right6Width: 18,
        right6Height: 18,
        right6Top: 277,
        right6Left: 408,

        right7Width: 18,
        right7Height: 18,
        right7Top: 306,
        right7Left: 408,

        right8Width: 38,
        right8Height: 18,
        right8Top: 334,
        right8Left: 398,

        right9Width: 38,
        right9Height: 18,
        right9Top: 373,
        right9Left: 398,

        right10Width: 38,
        right10Height: 18,
        right10Top: 401,
        right10Left: 398,

        right11Width: 38,
        right11Height: 18,
        right11Top: 431,
        right11Left: 398,

        right12Width: 38,
        right12Height: 18,
        right12Top: 461,
        right12Left: 398,

        right13Width: 18,
        right13Height: 18,
        right13Top: 484,
        right13Left: 408,

        right14Width: 18,
        right14Height: 18,
        right14Top: 513,
        right14Left: 408,
      },
      sv: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 139,
        headerTop: 38,

        wordwrap: 'break-word',
        lineHeight: 7,
        letterspacing: -0.1,
        textResize: 12,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 18,
        left3Height: 18,
        left3Top: 191,
        left3Left: 53,

        left4Width: 18,
        left4Height: 18,
        left4Top: 220,
        left4Left: 53,

        left5Width: 18,
        left5Height: 18,
        left5Top: 249,
        left5Left: 53,

        left6Width: 18,
        left6Height: 18,
        left6Top: 279,
        left6Left: 53,

        left7Width: 18,
        left7Height: 18,
        left7Top: 307,
        left7Left: 53,

        left8Width: 18,
        left8Height: 18,
        left8Top: 336,
        left8Left: 53,

        left9Width: 18,
        left9Height: 18,
        left9Top: 365,
        left9Left: 53,

        left10Width: 18,
        left10Height: 18,
        left10Top: 396,
        left10Left: 53,

        left11Width: 18,
        left11Height: 18,
        left11Top: 424,
        left11Left: 53,

        left12Width: 18,
        left12Height: 18,
        left12Top: 452,
        left12Left: 53,

        left13Width: 18,
        left13Height: 18,
        left13Top: 482,
        left13Left: 53,

        left14Width: 18,
        left14Height: 18,
        left14Top: 511,
        left14Left: 53,

        right1Width: 18,
        right1Height: 18,
        right1Top: 133,
        right1Left: 407,

        right2Width: 18,
        right2Height: 18,
        right2Top: 162,
        right2Left: 407,

        right3Width: 18,
        right3Height: 18,
        right3Top: 191,
        right3Left: 407,

        right4Width: 18,
        right4Height: 18,
        right4Top: 219,
        right4Left: 407,

        right5Width: 18,
        right5Height: 18,
        right5Top: 248,
        right5Left: 407,

        right6Width: 18,
        right6Height: 18,
        right6Top: 278,
        right6Left: 407,

        right7Width: 18,
        right7Height: 18,
        right7Top: 307,
        right7Left: 407,

        right8Width: 18,
        right8Height: 18,
        right8Top: 334,
        right8Left: 405,

        right9Width: 33,
        right9Height: 18,
        right9Top: 367,
        right9Left: 400,

        right10Width: 33,
        right10Height: 18,
        right10Top: 396,
        right10Left: 400,

        right11Width: 33,
        right11Height: 18,
        right11Top: 425,
        right11Left: 400,

        right12Width: 33,
        right12Height: 18,
        right12Top: 456,
        right12Left: 400,

        right13Width: 18,
        right13Height: 18,
        right13Top: 482,
        right13Left: 408,

        right14Width: 18,
        right14Height: 18,
        right14Top: 510,
        right14Left: 407,
      },
      'ta-IN': {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 128,
        headerTop: 42,

        wordwrap: 'break-word',
        lineHeight: 10,
        letterspacing: -0.1,
        textResize: 7,
        symbolResize: 13,
        right4SymbolResize: 16,
        right7SymbolResize: 16,

        left3Width: 18,
        left3Height: 18,
        left3Top: 191,
        left3Left: 51,

        left4Width: 18,
        left4Height: 18,
        left4Top: 220,
        left4Left: 51,

        left5Width: 18,
        left5Height: 18,
        left5Top: 249,
        left5Left: 51,

        left6Width: 18,
        left6Height: 18,
        left6Top: 278,
        left6Left: 51,

        left7Width: 18,
        left7Height: 18,
        left7Top: 307,
        left7Left: 51,

        left8Width: 18,
        left8Height: 18,
        left8Top: 337,
        left8Left: 51,

        left9Width: 18,
        left9Height: 18,
        left9Top: 366,
        left9Left: 51,

        left10Width: 18,
        left10Height: 18,
        left10Top: 396,
        left10Left: 51,

        left11Width: 18,
        left11Height: 18,
        left11Top: 424,
        left11Left: 51,

        left12Width: 18,
        left12Height: 18,
        left12Top: 454,
        left12Left: 51,

        left13Width: 18,
        left13Height: 18,
        left13Top: 481,
        left13Left: 50,

        left14Width: 18,
        left14Height: 18,
        left14Top: 510,
        left14Left: 51,

        right1Width: 18,
        right1Height: 18,
        right1Top: 132,
        right1Left: 408,

        right2Width: 18,
        right2Height: 18,
        right2Top: 161,
        right2Left: 408,

        right3Width: 18,
        right3Height: 18,
        right3Top: 189,
        right3Left: 408,

        right4Width: 18,
        right4Height: 18,
        right4Top: 215,
        right4Left: 409,

        right5Width: 18,
        right5Height: 18,
        right5Top: 248,
        right5Left: 408,

        right6Width: 18,
        right6Height: 18,
        right6Top: 277,
        right6Left: 408,

        right7Width: 18,
        right7Height: 18,
        right7Top: 303,
        right7Left: 408,

        right8Width: 38,
        right8Height: 18,
        right8Top: 336,
        right8Left: 398,

        right9Width: 38,
        right9Height: 18,
        right9Top: 366,
        right9Left: 398,

        right10Width: 38,
        right10Height: 18,
        right10Top: 394,
        right10Left: 398,

        right11Width: 38,
        right11Height: 18,
        right11Top: 424,
        right11Left: 398,

        right12Width: 38,
        right12Height: 18,
        right12Top: 454,
        right12Left: 398,

        right13Width: 18,
        right13Height: 18,
        right13Top: 484,
        right13Left: 408,

        right14Width: 18,
        right14Height: 18,
        right14Top: 512,
        right14Left: 408,
      },
      th: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 226,
        headerTop: 37,

        wordwrap: 'normal',
        lineHeight: 0,
        letterspacing: 0,
        textResize: 11,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 18,
        left3Height: 18,
        left3Top: 188,
        left3Left: 71,

        left4Width: 18,
        left4Height: 18,
        left4Top: 219,
        left4Left: 72,

        left5Width: 18,
        left5Height: 18,
        left5Top: 242,
        left5Left: 71,

        left6Width: 18,
        left6Height: 18,
        left6Top: 276,
        left6Left: 71,

        left7Width: 18,
        left7Height: 18,
        left7Top: 304,
        left7Left: 71,

        left8Width: 18,
        left8Height: 18,
        left8Top: 330,
        left8Left: 72,

        left9Width: 18,
        left9Height: 18,
        left9Top: 371,
        left9Left: 75,

        left10Width: 18,
        left10Height: 18,
        left10Top: 393,
        left10Left: 71,

        left11Width: 18,
        left11Height: 18,
        left11Top: 422,
        left11Left: 71,

        left12Width: 18,
        left12Height: 18,
        left12Top: 452,
        left12Left: 72,

        left13Width: 18,
        left13Height: 18,
        left13Top: 481,
        left13Left: 71,

        left14Width: 18,
        left14Height: 18,
        left14Top: 509,
        left14Left: 71,

        right1Width: 18,
        right1Height: 18,
        right1Top: 132,
        right1Left: 407,

        right2Width: 18,
        right2Height: 18,
        right2Top: 161,
        right2Left: 407,

        right3Width: 18,
        right3Height: 18,
        right3Top: 191,
        right3Left: 408,

        right4Width: 18,
        right4Height: 18,
        right4Top: 219,
        right4Left: 407,

        right5Width: 18,
        right5Height: 18,
        right5Top: 250,
        right5Left: 407,

        right6Width: 18,
        right6Height: 18,
        right6Top: 279,
        right6Left: 407,

        right7Width: 18,
        right7Height: 18,
        right7Top: 308,
        right7Left: 407,

        right8Width: 28,
        right8Height: 18,
        right8Top: 334,
        right8Left: 402,

        right9Width: 35,
        right9Height: 18,
        right9Top: 373,
        right9Left: 399,

        right10Width: 35,
        right10Height: 18,
        right10Top: 402,
        right10Left: 399,

        right11Width: 35,
        right11Height: 18,
        right11Top: 431,
        right11Left: 399,

        right12Width: 35,
        right12Height: 18,
        right12Top: 462,
        right12Left: 399,

        right13Width: 18,
        right13Height: 18,
        right13Top: 482,
        right13Left: 407,

        right14Width: 18,
        right14Height: 18,
        right14Top: 511,
        right14Left: 407,
      },
      tr: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 126,
        headerTop: 38,

        wordwrap: 'normal',
        lineHeight: 0,
        letterspacing: -0.05,
        textResize: 10,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 18,
        left3Height: 18,
        left3Top: 188,
        left3Left: 53,

        left4Width: 18,
        left4Height: 18,
        left4Top: 216,
        left4Left: 53,

        left5Width: 18,
        left5Height: 18,
        left5Top: 246,
        left5Left: 53,

        left6Width: 18,
        left6Height: 18,
        left6Top: 275,
        left6Left: 53,

        left7Width: 18,
        left7Height: 18,
        left7Top: 304,
        left7Left: 53,

        left8Width: 18,
        left8Height: 18,
        left8Top: 336,
        left8Left: 53,

        left9Width: 18,
        left9Height: 18,
        left9Top: 366,
        left9Left: 53,

        left10Width: 18,
        left10Height: 18,
        left10Top: 395,
        left10Left: 53,

        left11Width: 18,
        left11Height: 18,
        left11Top: 424,
        left11Left: 53,

        left12Width: 18,
        left12Height: 18,
        left12Top: 454,
        left12Left: 53,

        left13Width: 18,
        left13Height: 18,
        left13Top: 483,
        left13Left: 53,

        left14Width: 18,
        left14Height: 18,
        left14Top: 511,
        left14Left: 53,

        right1Width: 18,
        right1Height: 18,
        right1Top: 130,
        right1Left: 408,

        right2Width: 18,
        right2Height: 18,
        right2Top: 159,
        right2Left: 407,

        right3Width: 18,
        right3Height: 18,
        right3Top: 188,
        right3Left: 407,

        right4Width: 18,
        right4Height: 18,
        right4Top: 216,
        right4Left: 407,

        right5Width: 18,
        right5Height: 18,
        right5Top: 246,
        right5Left: 407,

        right6Width: 18,
        right6Height: 18,
        right6Top: 274,
        right6Left: 407,

        right7Width: 18,
        right7Height: 18,
        right7Top: 304,
        right7Left: 407,

        right8Width: 28,
        right8Height: 18,
        right8Top: 332,
        right8Left: 402,

        right9Width: 35,
        right9Height: 18,
        right9Top: 372,
        right9Left: 399,

        right10Width: 35,
        right10Height: 18,
        right10Top: 401,
        right10Left: 399,

        right11Width: 35,
        right11Height: 18,
        right11Top: 431,
        right11Left: 399,

        right12Width: 35,
        right12Height: 18,
        right12Top: 461,
        right12Left: 399,

        right13Width: 18,
        right13Height: 18,
        right13Top: 482,
        right13Left: 407,

        right14Width: 18,
        right14Height: 18,
        right14Top: 510,
        right14Left: 407,
      },
      ua: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 127,
        headerTop: 40,

        wordwrap: 'normal',
        lineHeight: 0,
        letterspacing: -0.07,
        textResize: 11,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 18,
        left3Height: 18,
        left3Top: 190,
        left3Left: 51,

        left4Width: 18,
        left4Height: 18,
        left4Top: 218,
        left4Left: 51,

        left5Width: 18,
        left5Height: 18,
        left5Top: 247,
        left5Left: 51,

        left6Width: 18,
        left6Height: 18,
        left6Top: 276,
        left6Left: 51,

        left7Width: 18,
        left7Height: 18,
        left7Top: 306,
        left7Left: 51,

        left8Width: 18,
        left8Height: 18,
        left8Top: 335,
        left8Left: 51,

        left9Width: 18,
        left9Height: 18,
        left9Top: 365,
        left9Left: 51,

        left10Width: 18,
        left10Height: 18,
        left10Top: 395,
        left10Left: 51,

        left11Width: 18,
        left11Height: 18,
        left11Top: 424,
        left11Left: 51,

        left12Width: 18,
        left12Height: 18,
        left12Top: 453,
        left12Left: 51,

        left13Width: 18,
        left13Height: 18,
        left13Top: 481,
        left13Left: 51,

        left14Width: 18,
        left14Height: 18,
        left14Top: 511,
        left14Left: 51,

        right1Width: 18,
        right1Height: 18,
        right1Top: 132,
        right1Left: 407,

        right2Width: 18,
        right2Height: 18,
        right2Top: 161,
        right2Left: 407,

        right3Width: 18,
        right3Height: 18,
        right3Top: 190,
        right3Left: 407,

        right4Width: 18,
        right4Height: 18,
        right4Top: 218,
        right4Left: 407,

        right5Width: 18,
        right5Height: 18,
        right5Top: 248,
        right5Left: 407,

        right6Width: 18,
        right6Height: 18,
        right6Top: 277,
        right6Left: 407,

        right7Width: 18,
        right7Height: 18,
        right7Top: 306,
        right7Left: 407,

        right8Width: 39,
        right8Height: 18,
        right8Top: 335,
        right8Left: 398,

        right9Width: 39,
        right9Height: 18,
        right9Top: 373,
        right9Left: 397,

        right10Width: 39,
        right10Height: 18,
        right10Top: 402,
        right10Left: 397,

        right11Width: 39,
        right11Height: 18,
        right11Top: 431,
        right11Left: 397,

        right12Width: 39,
        right12Height: 18,
        right12Top: 461,
        right12Left: 397,

        right13Width: 18,
        right13Height: 18,
        right13Top: 483,
        right13Left: 408,

        right14Width: 18,
        right14Height: 18,
        right14Top: 513,
        right14Left: 408,
      },
      vi: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 130,
        headerTop: 40,

        wordwrap: 'normal',
        lineHeight: 8,
        letterspacing: 0,
        textResize: 11,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 18,
        left3Height: 18,
        left3Top: 190,
        left3Left: 54,

        left4Width: 18,
        left4Height: 18,
        left4Top: 218,
        left4Left: 54,

        left5Width: 18,
        left5Height: 18,
        left5Top: 247,
        left5Left: 54,

        left6Width: 18,
        left6Height: 18,
        left6Top: 276,
        left6Left: 54,

        left7Width: 18,
        left7Height: 18,
        left7Top: 308,
        left7Left: 54,

        left8Width: 18,
        left8Height: 18,
        left8Top: 342,
        left8Left: 58,

        left9Width: 18,
        left9Height: 18,
        left9Top: 365,
        left9Left: 54,

        left10Width: 18,
        left10Height: 18,
        left10Top: 399,
        left10Left: 54,

        left11Width: 18,
        left11Height: 18,
        left11Top: 417,
        left11Left: 58,

        left12Width: 18,
        left12Height: 18,
        left12Top: 452,
        left12Left: 54,

        left13Width: 18,
        left13Height: 18,
        left13Top: 481,
        left13Left: 54,

        left14Width: 18,
        left14Height: 18,
        left14Top: 511,
        left14Left: 54,

        right1Width: 18,
        right1Height: 18,
        right1Top: 131,
        right1Left: 408,

        right2Width: 18,
        right2Height: 18,
        right2Top: 160,
        right2Left: 407,

        right3Width: 18,
        right3Height: 18,
        right3Top: 189,
        right3Left: 407,

        right4Width: 18,
        right4Height: 18,
        right4Top: 217,
        right4Left: 408,

        right5Width: 18,
        right5Height: 18,
        right5Top: 247,
        right5Left: 407,

        right6Width: 18,
        right6Height: 18,
        right6Top: 276,
        right6Left: 408,

        right7Width: 18,
        right7Height: 18,
        right7Top: 305,
        right7Left: 407,

        right8Width: 28,
        right8Height: 18,
        right8Top: 333,
        right8Left: 402,

        right9Width: 35,
        right9Height: 18,
        right9Top: 365,
        right9Left: 399,

        right10Width: 35,
        right10Height: 18,
        right10Top: 393,
        right10Left: 399,

        right11Width: 35,
        right11Height: 18,
        right11Top: 423,
        right11Left: 399,

        right12Width: 35,
        right12Height: 18,
        right12Top: 453,
        right12Left: 399,

        right13Width: 18,
        right13Height: 18,
        right13Top: 482,
        right13Left: 407,

        right14Width: 18,
        right14Height: 18,
        right14Top: 511,
        right14Left: 407,
      },
      'zh-Hans': {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 221,
        headerTop: 36,

        wordwrap: 'normal',
        lineHeight: 0,
        letterspacing: 0,
        textResize: 11,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 18,
        left3Height: 18,
        left3Top: 189,
        left3Left: 84,

        left4Width: 18,
        left4Height: 18,
        left4Top: 218,
        left4Left: 84,

        left5Width: 18,
        left5Height: 18,
        left5Top: 247,
        left5Left: 84,

        left6Width: 18,
        left6Height: 18,
        left6Top: 277,
        left6Left: 84,

        left7Width: 18,
        left7Height: 18,
        left7Top: 306,
        left7Left: 84,

        left8Width: 18,
        left8Height: 18,
        left8Top: 336,
        left8Left: 84,

        left9Width: 18,
        left9Height: 18,
        left9Top: 365,
        left9Left: 84,

        left10Width: 18,
        left10Height: 18,
        left10Top: 394,
        left10Left: 84,

        left11Width: 18,
        left11Height: 18,
        left11Top: 424,
        left11Left: 84,

        left12Width: 18,
        left12Height: 18,
        left12Top: 453,
        left12Left: 84,

        left13Width: 18,
        left13Height: 18,
        left13Top: 481,
        left13Left: 84,

        left14Width: 18,
        left14Height: 18,
        left14Top: 510,
        left14Left: 84,

        right1Width: 18,
        right1Height: 18,
        right1Top: 133,
        right1Left: 408,

        right2Width: 18,
        right2Height: 18,
        right2Top: 161,
        right2Left: 408,

        right3Width: 18,
        right3Height: 18,
        right3Top: 191,
        right3Left: 408,

        right4Width: 18,
        right4Height: 18,
        right4Top: 219,
        right4Left: 408,

        right5Width: 18,
        right5Height: 18,
        right5Top: 249,
        right5Left: 407,

        right6Width: 18,
        right6Height: 18,
        right6Top: 278,
        right6Left: 408,

        right7Width: 18,
        right7Height: 18,
        right7Top: 306,
        right7Left: 408,

        right8Width: 38,
        right8Height: 18,
        right8Top: 334,
        right8Left: 398,

        right9Width: 38,
        right9Height: 18,
        right9Top: 373,
        right9Left: 398,

        right10Width: 38,
        right10Height: 18,
        right10Top: 402,
        right10Left: 398,

        right11Width: 38,
        right11Height: 18,
        right11Top: 432,
        right11Left: 398,

        right12Width: 38,
        right12Height: 18,
        right12Top: 462,
        right12Left: 398,

        right13Width: 18,
        right13Height: 18,
        right13Top: 482,
        right13Left: 408,

        right14Width: 18,
        right14Height: 18,
        right14Top: 512,
        right14Left: 408,
      },
      'zh-Hant': {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 221,
        headerTop: 36,

        wordwrap: 'normal',
        lineHeight: 0,
        letterspacing: -0.09,
        textResize: 11,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 18,
        left3Height: 18,
        left3Top: 189,
        left3Left: 84,

        left4Width: 18,
        left4Height: 18,
        left4Top: 218,
        left4Left: 84,

        left5Width: 18,
        left5Height: 18,
        left5Top: 247,
        left5Left: 84,

        left6Width: 18,
        left6Height: 18,
        left6Top: 277,
        left6Left: 84,

        left7Width: 18,
        left7Height: 18,
        left7Top: 306,
        left7Left: 84,

        left8Width: 18,
        left8Height: 18,
        left8Top: 336,
        left8Left: 84,

        left9Width: 18,
        left9Height: 18,
        left9Top: 365,
        left9Left: 84,

        left10Width: 18,
        left10Height: 18,
        left10Top: 394,
        left10Left: 84,

        left11Width: 18,
        left11Height: 18,
        left11Top: 424,
        left11Left: 84,

        left12Width: 18,
        left12Height: 18,
        left12Top: 453,
        left12Left: 84,

        left13Width: 18,
        left13Height: 18,
        left13Top: 481,
        left13Left: 84,

        left14Width: 18,
        left14Height: 18,
        left14Top: 510,
        left14Left: 84,

        right1Width: 18,
        right1Height: 18,
        right1Top: 133,
        right1Left: 408,

        right2Width: 18,
        right2Height: 18,
        right2Top: 161,
        right2Left: 408,

        right3Width: 18,
        right3Height: 18,
        right3Top: 191,
        right3Left: 408,

        right4Width: 18,
        right4Height: 18,
        right4Top: 219,
        right4Left: 408,

        right5Width: 18,
        right5Height: 18,
        right5Top: 249,
        right5Left: 407,

        right6Width: 18,
        right6Height: 18,
        right6Top: 278,
        right6Left: 408,

        right7Width: 18,
        right7Height: 18,
        right7Top: 306,
        right7Left: 408,

        right8Width: 18,
        right8Height: 18,
        right8Top: 334,
        right8Left: 406,

        right9Width: 34,
        right9Height: 18,
        right9Top: 373,
        right9Left: 400,

        right10Width: 34,
        right10Height: 18,
        right10Top: 401,
        right10Left: 400,

        right11Width: 34,
        right11Height: 18,
        right11Top: 431,
        right11Left: 400,

        right12Width: 34,
        right12Height: 18,
        right12Top: 461,
        right12Left: 400,

        right13Width: 18,
        right13Height: 18,
        right13Top: 482,
        right13Left: 408,

        right14Width: 18,
        right14Height: 18,
        right14Top: 512,
        right14Left: 408,
      },
    };
  }

  public static get SPLITTOPCARDSPOSITION(): any {
    return {
      ar: {
        width: 815,
        height: 599,
        left: 0,
        top: 0,
        splitCardWidth: 142,
        splitCardHeight: 186,
        splitCard1Top: 312,
        splitCard1Left: 538,
        splitCard2Top: 312,
        splitCard2Left: 612,
        splitCard3Left: 296,
        splitCard4Left: 76,
      },
      bg: {
        width: 815,
        height: 599,
        left: 0,
        top: 32,
        splitCardWidth: 142,
        splitCardHeight: 186,
        splitCard1Top: 312,
        splitCard1Left: 64,
        splitCard2Top: 312,
        splitCard2Left: 135,
        splitCard3Left: 304,
        splitCard4Left: 530,
      },
      cs: {
        width: 815,
        height: 599,
        left: 0,
        top: 11,
        splitCardWidth: 142,
        splitCardHeight: 186,
        splitCard1Top: 291,
        splitCard1Left: 64,
        splitCard2Top: 291,
        splitCard2Left: 135,
        splitCard3Left: 304,
        splitCard4Left: 530,
      },
      da: {
        width: 815,
        height: 599,
        left: 0,
        top: 16,
        splitCardWidth: 142,
        splitCardHeight: 186,
        splitCard1Top: 296,
        splitCard1Left: 64,
        splitCard2Top: 296,
        splitCard2Left: 135,
        splitCard3Left: 304,
        splitCard4Left: 530,
      },
      de: {
        width: 815,
        height: 599,
        left: 0,
        top: 15,
        splitCardWidth: 142,
        splitCardHeight: 186,
        splitCard1Top: 295,
        splitCard1Left: 64,
        splitCard2Top: 295,
        splitCard2Left: 135,
        splitCard3Left: 304,
        splitCard4Left: 530,
      },
      ee: {
        width: 815,
        height: 599,
        left: 0,
        top: 32,
        splitCardWidth: 142,
        splitCardHeight: 186,
        splitCard1Top: 312,
        splitCard1Left: 64,
        splitCard2Top: 312,
        splitCard2Left: 135,
        splitCard3Left: 304,
        splitCard4Left: 530,
      },
      en: {
        width: 815,
        height: 599,
        left: 0,
        top: 0,
        splitCardWidth: 142,
        splitCardHeight: 186,
        splitCard1Top: 280,
        splitCard1Left: 64,
        splitCard2Top: 280,
        splitCard2Left: 135,
        splitCard3Left: 304,
        splitCard4Left: 530,
      },
      es: {
        width: 815,
        height: 599,
        left: 0,
        top: 3,
        splitCardWidth: 142,
        splitCardHeight: 186,
        splitCard1Top: 283,
        splitCard1Left: 64,
        splitCard2Top: 283,
        splitCard2Left: 135,
        splitCard3Left: 304,
        splitCard4Left: 530,
      },
      fi: {
        width: 815,
        height: 599,
        left: 0,
        top: 0,
        splitCardWidth: 142,
        splitCardHeight: 186,
        splitCard1Top: 280,
        splitCard1Left: 64,
        splitCard2Top: 280,
        splitCard2Left: 135,
        splitCard3Left: 304,
        splitCard4Left: 530,
      },
      fr: {
        width: 815,
        height: 599,
        left: 0,
        top: 28,
        splitCardWidth: 142,
        splitCardHeight: 186,
        splitCard1Top: 308,
        splitCard1Left: 64,
        splitCard2Top: 308,
        splitCard2Left: 135,
        splitCard3Left: 304,
        splitCard4Left: 530,
      },
      ge: {
        width: 815,
        height: 599,
        left: 0,
        top: 14,
        splitCardWidth: 142,
        splitCardHeight: 186,
        splitCard1Top: 294,
        splitCard1Left: 64,
        splitCard2Top: 294,
        splitCard2Left: 135,
        splitCard3Left: 304,
        splitCard4Left: 530,
      },
      gr: {
        width: 815,
        height: 599,
        left: 0,
        top: 23,
        splitCardWidth: 142,
        splitCardHeight: 186,
        splitCard1Top: 303,
        splitCard1Left: 64,
        splitCard2Top: 303,
        splitCard2Left: 135,
        splitCard3Left: 304,
        splitCard4Left: 530,
      },
      he: {
        width: 815,
        height: 599,
        left: 0,
        top: 10,
        splitCardWidth: 142,
        splitCardHeight: 186,
        splitCard1Top: 319,
        splitCard1Left: 538,
        splitCard2Top: 319,
        splitCard2Left: 612,
        splitCard3Left: 296,
        splitCard4Left: 76,
      },
      'hi-IN': {
        width: 815,
        height: 599,
        left: 0,
        top: 35,
        splitCardWidth: 142,
        splitCardHeight: 186,
        splitCard1Top: 315,
        splitCard1Left: 64,
        splitCard2Top: 315,
        splitCard2Left: 135,
        splitCard3Left: 304,
        splitCard4Left: 530,
      },
      hu: {
        width: 815,
        height: 599,
        left: 0,
        top: 25,
        splitCardWidth: 142,
        splitCardHeight: 186,
        splitCard1Top: 305,
        splitCard1Left: 64,
        splitCard2Top: 305,
        splitCard2Left: 135,
        splitCard3Left: 304,
        splitCard4Left: 530,
      },
      hy: {
        width: 815,
        height: 599,
        left: 0,
        top: 23,
        splitCardWidth: 142,
        splitCardHeight: 186,
        splitCard1Top: 303,
        splitCard1Left: 64,
        splitCard2Top: 303,
        splitCard2Left: 135,
        splitCard3Left: 304,
        splitCard4Left: 530,
      },
      id: {
        width: 815,
        height: 599,
        left: 0,
        top: 16,
        splitCardWidth: 142,
        splitCardHeight: 186,
        splitCard1Top: 296,
        splitCard1Left: 64,
        splitCard2Top: 296,
        splitCard2Left: 135,
        splitCard3Left: 304,
        splitCard4Left: 530,
      },
      it: {
        width: 815,
        height: 599,
        left: 0,
        top: 0,
        splitCardWidth: 142,
        splitCardHeight: 186,
        splitCard1Top: 284,
        splitCard1Left: 64,
        splitCard2Top: 284,
        splitCard2Left: 135,
        splitCard3Left: 304,
        splitCard4Left: 530,
      },
      ja: {
        width: 815,
        height: 599,
        left: 0,
        top: 25,
        splitCardWidth: 142,
        splitCardHeight: 186,
        splitCard1Top: 305,
        splitCard1Left: 64,
        splitCard2Top: 305,
        splitCard2Left: 135,
        splitCard3Left: 304,
        splitCard4Left: 530,
      },
      kh: {
        width: 815,
        height: 599,
        left: 0,
        top: 14,
        splitCardWidth: 142,
        splitCardHeight: 186,
        splitCard1Top: 294,
        splitCard1Left: 64,
        splitCard2Top: 294,
        splitCard2Left: 135,
        splitCard3Left: 304,
        splitCard4Left: 530,
      },
      ko: {
        width: 815,
        height: 599,
        left: 0,
        top: 18,
        splitCardWidth: 142,
        splitCardHeight: 186,
        splitCard1Top: 298,
        splitCard1Left: 64,
        splitCard2Top: 298,
        splitCard2Left: 135,
        splitCard3Left: 304,
        splitCard4Left: 530,
      },
      lt: {
        width: 815,
        height: 599,
        left: 0,
        top: 28,
        splitCardWidth: 142,
        splitCardHeight: 186,
        splitCard1Top: 308,
        splitCard1Left: 64,
        splitCard2Top: 308,
        splitCard2Left: 135,
        splitCard3Left: 304,
        splitCard4Left: 530,
      },
      lv: {
        width: 815,
        height: 599,
        left: 0,
        top: 21,
        splitCardWidth: 142,
        splitCardHeight: 186,
        splitCard1Top: 301,
        splitCard1Left: 64,
        splitCard2Top: 301,
        splitCard2Left: 135,
        splitCard3Left: 304,
        splitCard4Left: 530,
      },
      mt: {
        width: 815,
        height: 599,
        left: 0,
        top: 35,
        splitCardWidth: 142,
        splitCardHeight: 186,
        splitCard1Top: 315,
        splitCard1Left: 64,
        splitCard2Top: 315,
        splitCard2Left: 135,
        splitCard3Left: 304,
        splitCard4Left: 530,
      },
      my: {
        width: 815,
        height: 599,
        left: 0,
        top: 42,
        splitCardWidth: 142,
        splitCardHeight: 186,
        splitCard1Top: 322,
        splitCard1Left: 64,
        splitCard2Top: 322,
        splitCard2Left: 135,
        splitCard3Left: 304,
        splitCard4Left: 530,
      },
      nb: {
        width: 815,
        height: 599,
        left: 0,
        top: 12,
        splitCardWidth: 142,
        splitCardHeight: 186,
        splitCard1Top: 292,
        splitCard1Left: 64,
        splitCard2Top: 292,
        splitCard2Left: 135,
        splitCard3Left: 304,
        splitCard4Left: 530,
      },
      nl: {
        width: 815,
        height: 599,
        left: 0,
        top: 16,
        splitCardWidth: 142,
        splitCardHeight: 186,
        splitCard1Top: 296,
        splitCard1Left: 64,
        splitCard2Top: 296,
        splitCard2Left: 135,
        splitCard3Left: 304,
        splitCard4Left: 530,
      },
      ph: {
        width: 815,
        height: 599,
        left: 0,
        top: 35,
        splitCardWidth: 142,
        splitCardHeight: 186,
        splitCard1Top: 315,
        splitCard1Left: 64,
        splitCard2Top: 315,
        splitCard2Left: 135,
        splitCard3Left: 304,
        splitCard4Left: 530,
      },
      pl: {
        width: 815,
        height: 599,
        left: 0,
        top: 23,
        splitCardWidth: 142,
        splitCardHeight: 186,
        splitCard1Top: 303,
        splitCard1Left: 64,
        splitCard2Top: 303,
        splitCard2Left: 135,
        splitCard3Left: 304,
        splitCard4Left: 530,
      },
      'pt-BR': {
        width: 815,
        height: 599,
        left: 0,
        top: 4,
        splitCardWidth: 142,
        splitCardHeight: 186,
        splitCard1Top: 284,
        splitCard1Left: 64,
        splitCard2Top: 284,
        splitCard2Left: 135,
        splitCard3Left: 304,
        splitCard4Left: 530,
      },
      ro: {
        width: 815,
        height: 599,
        left: 0,
        top: 25,
        splitCardWidth: 142,
        splitCardHeight: 186,
        splitCard1Top: 305,
        splitCard1Left: 64,
        splitCard2Top: 305,
        splitCard2Left: 135,
        splitCard3Left: 304,
        splitCard4Left: 530,
      },
      ru: {
        width: 815,
        height: 599,
        left: 0,
        top: 16,
        splitCardWidth: 142,
        splitCardHeight: 186,
        splitCard1Top: 296,
        splitCard1Left: 64,
        splitCard2Top: 296,
        splitCard2Left: 135,
        splitCard3Left: 304,
        splitCard4Left: 530,
      },
      si: {
        width: 815,
        height: 599,
        left: 0,
        top: 30,
        splitCardWidth: 142,
        splitCardHeight: 186,
        splitCard1Top: 310,
        splitCard1Left: 64,
        splitCard2Top: 310,
        splitCard2Left: 135,
        splitCard3Left: 304,
        splitCard4Left: 530,
      },
      sk: {
        width: 815,
        height: 599,
        left: 0,
        top: 35,
        splitCardWidth: 142,
        splitCardHeight: 186,
        splitCard1Top: 315,
        splitCard1Left: 64,
        splitCard2Top: 315,
        splitCard2Left: 135,
        splitCard3Left: 304,
        splitCard4Left: 530,
      },
      'sr-RS': {
        width: 815,
        height: 599,
        left: 0,
        top: 37,
        splitCardWidth: 142,
        splitCardHeight: 186,
        splitCard1Top: 317,
        splitCard1Left: 64,
        splitCard2Top: 317,
        splitCard2Left: 135,
        splitCard3Left: 304,
        splitCard4Left: 530,
      },
      sv: {
        width: 815,
        height: 599,
        left: 0,
        top: 5,
        splitCardWidth: 142,
        splitCardHeight: 186,
        splitCard1Top: 285,
        splitCard1Left: 64,
        splitCard2Top: 285,
        splitCard2Left: 135,
        splitCard3Left: 304,
        splitCard4Left: 530,
      },
      'ta-IN': {
        width: 815,
        height: 599,
        left: 0,
        top: 47,
        splitCardWidth: 142,
        splitCardHeight: 186,
        splitCard1Top: 327,
        splitCard1Left: 64,
        splitCard2Top: 327,
        splitCard2Left: 135,
        splitCard3Left: 304,
        splitCard4Left: 530,
      },
      th: {
        width: 815,
        height: 599,
        left: 0,
        top: 21,
        splitCardWidth: 142,
        splitCardHeight: 186,
        splitCard1Top: 301,
        splitCard1Left: 64,
        splitCard2Top: 301,
        splitCard2Left: 135,
        splitCard3Left: 304,
        splitCard4Left: 530,
      },
      tr: {
        width: 815,
        height: 599,
        left: 0,
        top: 28,
        splitCardWidth: 142,
        splitCardHeight: 186,
        splitCard1Top: 308,
        splitCard1Left: 64,
        splitCard2Top: 308,
        splitCard2Left: 135,
        splitCard3Left: 304,
        splitCard4Left: 530,
      },
      ua: {
        width: 815,
        height: 599,
        left: 0,
        top: 16,
        splitCardWidth: 142,
        splitCardHeight: 186,
        splitCard1Top: 296,
        splitCard1Left: 64,
        splitCard2Top: 296,
        splitCard2Left: 135,
        splitCard3Left: 304,
        splitCard4Left: 530,
      },
      vi: {
        width: 815,
        height: 599,
        left: 0,
        top: 14,
        splitCardWidth: 142,
        splitCardHeight: 186,
        splitCard1Top: 294,
        splitCard1Left: 64,
        splitCard2Top: 294,
        splitCard2Left: 135,
        splitCard3Left: 304,
        splitCard4Left: 530,
      },
      'zh-Hans': {
        width: 815,
        height: 599,
        left: 0,
        top: 19,
        splitCardWidth: 142,
        splitCardHeight: 186,
        splitCard1Top: 299,
        splitCard1Left: 64,
        splitCard2Top: 299,
        splitCard2Left: 135,
        splitCard3Left: 304,
        splitCard4Left: 530,
      },
      'zh-Hant': {
        width: 815,
        height: 599,
        left: 0,
        top: 21,
        splitCardWidth: 142,
        splitCardHeight: 186,
        splitCard1Top: 301,
        splitCard1Left: 64,
        splitCard2Top: 301,
        splitCard2Left: 135,
        splitCard3Left: 304,
        splitCard4Left: 530,
      },
    };
  }

  public static get SPLITCARDSPOSITION(): any {
    return {
      ar: {
        cardTop: 312,
        card1Left: 532,
        card2Left: 616,
        card3Left: 296,
        card4Left: 380,
        card5Left: 72,
        card6Left: 156,
        tutorial13Top: 342,
      },
      bg: {
        cardTop: 310,
        card1Left: 72,
        card2Left: 156,
        card3Left: 296,
        card4Left: 380,
        card5Left: 532,
        card6Left: 616,
        tutorial13Top: 338,
      },
      cs: {
        cardTop: 310,
        card1Left: 72,
        card2Left: 156,
        card3Left: 296,
        card4Left: 380,
        card5Left: 532,
        card6Left: 616,
        tutorial13Top: 320,
      },
      da: {
        cardTop: 300,
        card1Left: 72,
        card2Left: 156,
        card3Left: 296,
        card4Left: 380,
        card5Left: 532,
        card6Left: 616,
        tutorial13Top: 323,
      },
      de: {
        cardTop: 300,
        card1Left: 72,
        card2Left: 156,
        card3Left: 296,
        card4Left: 380,
        card5Left: 532,
        card6Left: 616,
        tutorial13Top: 321,
      },
      ee: {
        cardTop: 310,
        card1Left: 72,
        card2Left: 156,
        card3Left: 296,
        card4Left: 380,
        card5Left: 532,
        card6Left: 616,
        tutorial13Top: 337,
      },
      en: {
        cardTop: 310,
        card1Left: 72,
        card2Left: 156,
        card3Left: 296,
        card4Left: 380,
        card5Left: 532,
        card6Left: 616,
        tutorial13Top: 299,
      },
      es: {
        cardTop: 304,
        card1Left: 72,
        card2Left: 156,
        card3Left: 296,
        card4Left: 380,
        card5Left: 532,
        card6Left: 616,
        tutorial13Top: 309,
      },
      fi: {
        cardTop: 306,
        card1Left: 72,
        card2Left: 156,
        card3Left: 296,
        card4Left: 380,
        card5Left: 532,
        card6Left: 616,
        tutorial13Top: 305,
      },
      fr: {
        cardTop: 310,
        card1Left: 72,
        card2Left: 156,
        card3Left: 296,
        card4Left: 380,
        card5Left: 532,
        card6Left: 616,
        tutorial13Top: 338,
      },
      ge: {
        cardTop: 310,
        card1Left: 72,
        card2Left: 156,
        card3Left: 296,
        card4Left: 380,
        card5Left: 532,
        card6Left: 616,
        tutorial13Top: 318,
      },
      gr: {
        cardTop: 310,
        card1Left: 72,
        card2Left: 156,
        card3Left: 296,
        card4Left: 380,
        card5Left: 532,
        card6Left: 616,
        tutorial13Top: 327,
      },
      he: {
        cardTop: 308,
        card1Left: 532,
        card2Left: 616,
        card3Left: 296,
        card4Left: 380,
        card5Left: 72,
        card6Left: 156,
        tutorial13Top: 342,
      },
      'hi-IN': {
        cardTop: 321,
        card1Left: 72,
        card2Left: 156,
        card3Left: 296,
        card4Left: 380,
        card5Left: 532,
        card6Left: 616,
        tutorial13Top: 338,
      },
      hu: {
        cardTop: 310,
        card1Left: 72,
        card2Left: 156,
        card3Left: 296,
        card4Left: 380,
        card5Left: 532,
        card6Left: 616,
        tutorial13Top: 330,
      },
      hy: {
        cardTop: 310,
        card1Left: 72,
        card2Left: 156,
        card3Left: 296,
        card4Left: 380,
        card5Left: 532,
        card6Left: 616,
        tutorial13Top: 327,
      },
      id: {
        cardTop: 310,
        card1Left: 72,
        card2Left: 156,
        card3Left: 296,
        card4Left: 380,
        card5Left: 532,
        card6Left: 616,
        tutorial13Top: 324,
      },
      it: {
        cardTop: 310,
        card1Left: 72,
        card2Left: 156,
        card3Left: 296,
        card4Left: 380,
        card5Left: 532,
        card6Left: 616,
        tutorial13Top: 313,
      },
      ja: {
        cardTop: 306,
        card1Left: 72,
        card2Left: 156,
        card3Left: 296,
        card4Left: 380,
        card5Left: 532,
        card6Left: 616,
        tutorial13Top: 333,
      },
      kh: {
        cardTop: 310,
        card1Left: 72,
        card2Left: 156,
        card3Left: 296,
        card4Left: 380,
        card5Left: 532,
        card6Left: 616,
        tutorial13Top: 319,
      },
      ko: {
        cardTop: 304,
        card1Left: 72,
        card2Left: 156,
        card3Left: 296,
        card4Left: 380,
        card5Left: 532,
        card6Left: 616,
        tutorial13Top: 326,
      },
      lt: {
        cardTop: 316,
        card1Left: 72,
        card2Left: 156,
        card3Left: 296,
        card4Left: 380,
        card5Left: 532,
        card6Left: 616,
        tutorial13Top: 338,
      },
      lv: {
        cardTop: 306,
        card1Left: 72,
        card2Left: 156,
        card3Left: 296,
        card4Left: 380,
        card5Left: 532,
        card6Left: 616,
        tutorial13Top: 328,
      },
      mt: {
        cardTop: 319,
        card1Left: 72,
        card2Left: 156,
        card3Left: 296,
        card4Left: 380,
        card5Left: 532,
        card6Left: 616,
        tutorial13Top: 342,
      },
      my: {
        cardTop: 310,
        card1Left: 72,
        card2Left: 156,
        card3Left: 296,
        card4Left: 380,
        card5Left: 532,
        card6Left: 616,
        tutorial13Top: 349,
      },
      nb: {
        cardTop: 306,
        card1Left: 72,
        card2Left: 156,
        card3Left: 296,
        card4Left: 380,
        card5Left: 532,
        card6Left: 616,
        tutorial13Top: 317,
      },
      nl: {
        cardTop: 303,
        card1Left: 72,
        card2Left: 156,
        card3Left: 296,
        card4Left: 380,
        card5Left: 532,
        card6Left: 616,
        tutorial13Top: 323,
      },
      ph: {
        cardTop: 306,
        card1Left: 72,
        card2Left: 156,
        card3Left: 296,
        card4Left: 380,
        card5Left: 532,
        card6Left: 616,
        tutorial13Top: 340,
      },
      pl: {
        cardTop: 306,
        card1Left: 72,
        card2Left: 156,
        card3Left: 296,
        card4Left: 380,
        card5Left: 532,
        card6Left: 616,
        tutorial13Top: 328,
      },
      'pt-BR': {
        cardTop: 308,
        card1Left: 72,
        card2Left: 156,
        card3Left: 296,
        card4Left: 380,
        card5Left: 532,
        card6Left: 616,
        tutorial13Top: 310,
      },
      ro: {
        cardTop: 306,
        card1Left: 72,
        card2Left: 156,
        card3Left: 296,
        card4Left: 380,
        card5Left: 532,
        card6Left: 616,
        tutorial13Top: 332,
      },
      ru: {
        cardTop: 306,
        card1Left: 72,
        card2Left: 156,
        card3Left: 296,
        card4Left: 380,
        card5Left: 532,
        card6Left: 616,
        tutorial13Top: 321,
      },
      si: {
        cardTop: 314,
        card1Left: 72,
        card2Left: 156,
        card3Left: 296,
        card4Left: 380,
        card5Left: 532,
        card6Left: 616,
        tutorial13Top: 336,
      },
      sk: {
        cardTop: 310,
        card1Left: 72,
        card2Left: 156,
        card3Left: 296,
        card4Left: 380,
        card5Left: 532,
        card6Left: 616,
        tutorial13Top: 342,
      },
      'sr-RS': {
        cardTop: 312,
        card1Left: 72,
        card2Left: 156,
        card3Left: 296,
        card4Left: 380,
        card5Left: 532,
        card6Left: 616,
        tutorial13Top: 342,
      },
      sv: {
        cardTop: 300,
        card1Left: 72,
        card2Left: 156,
        card3Left: 296,
        card4Left: 380,
        card5Left: 532,
        card6Left: 616,
        tutorial13Top: 310,
      },
      'ta-IN': {
        cardTop: 322,
        card1Left: 72,
        card2Left: 156,
        card3Left: 296,
        card4Left: 380,
        card5Left: 532,
        card6Left: 616,
        tutorial13Top: 353,
      },
      th: {
        cardTop: 310,
        card1Left: 72,
        card2Left: 156,
        card3Left: 296,
        card4Left: 380,
        card5Left: 532,
        card6Left: 616,
        tutorial13Top: 325,
      },
      tr: {
        cardTop: 306,
        card1Left: 72,
        card2Left: 156,
        card3Left: 296,
        card4Left: 380,
        card5Left: 532,
        card6Left: 616,
        tutorial13Top: 334,
      },
      ua: {
        cardTop: 319,
        card1Left: 72,
        card2Left: 156,
        card3Left: 296,
        card4Left: 380,
        card5Left: 532,
        card6Left: 616,
        tutorial13Top: 322,
      },
      vi: {
        cardTop: 310,
        card1Left: 72,
        card2Left: 156,
        card3Left: 296,
        card4Left: 380,
        card5Left: 532,
        card6Left: 616,
        tutorial13Top: 323,
      },
      'zh-Hans': {
        cardTop: 310,
        card1Left: 72,
        card2Left: 156,
        card3Left: 296,
        card4Left: 380,
        card5Left: 532,
        card6Left: 616,
        tutorial13Top: 324,
      },
      'zh-Hant': {
        cardTop: 310,
        card1Left: 72,
        card2Left: 156,
        card3Left: 296,
        card4Left: 380,
        card5Left: 532,
        card6Left: 616,
        tutorial13Top: 325,
      },
    };
  }

  public static get ROULETTEPOSITION(): any {
    return {
      ar: {
        bgWidth: 163,
        bgHeight: 209,
        bg17Left: 577,
        bg18Left: 407,
        bg19Left: 250,
        bg20Left: 85,
        bgTop: 326,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 706,
        handContainer18Left: 537,
        handContainer19Left: 379,
        handContainer20Left: 214,
        handContainerTop: 354,
      },
      bg: {
        bgWidth: 163,
        bgHeight: 209,
        bg17Left: 76,
        bg18Left: 247,
        bg19Left: 414,
        bg20Left: 581,
        bgTop: 326,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 204,
        handContainer18Left: 375,
        handContainer19Left: 543,
        handContainer20Left: 709,
        handContainerTop: 354,
      },
      cs: {
        bgWidth: 163,
        bgHeight: 209,
        bg17Left: 76,
        bg18Left: 247,
        bg19Left: 414,
        bg20Left: 585,
        bgTop: 326,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 204,
        handContainer18Left: 375,
        handContainer19Left: 541,
        handContainer20Left: 713,
        handContainerTop: 354,
      },
      da: {
        bgWidth: 163,
        bgHeight: 209,
        bg17Left: 78,
        bg18Left: 245,
        bg19Left: 405,
        bg20Left: 576,
        bgTop: 326,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 207,
        handContainer18Left: 374,
        handContainer19Left: 533,
        handContainer20Left: 703,
        handContainerTop: 354,
      },
      de: {
        bgWidth: 163,
        bgHeight: 209,
        bg17Left: 79,
        bg18Left: 250,
        bg19Left: 407,
        bg20Left: 578,
        bgTop: 326,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 207,
        handContainer18Left: 380,
        handContainer19Left: 553,
        handContainer20Left: 706,
        handContainerTop: 354,
      },
      ee: {
        bgWidth: 163,
        bgHeight: 209,
        bg17Left: 73,
        bg18Left: 240,
        bg19Left: 407,
        bg20Left: 574,
        bgTop: 326,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 201,
        handContainer18Left: 369,
        handContainer19Left: 535,
        handContainer20Left: 703,
        handContainerTop: 354,
      },
      en: {
        bgWidth: 163,
        bgHeight: 209,
        bg17Left: 79,
        bg18Left: 249,
        bg19Left: 417,
        bg20Left: 587,
        bgTop: 326,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 208,
        handContainer18Left: 377,
        handContainer19Left: 545,
        handContainer20Left: 714,
        handContainerTop: 354,
      },
      es: {
        bgWidth: 163,
        bgHeight: 209,
        bg17Left: 76,
        bg18Left: 243,
        bg19Left: 411,
        bg20Left: 581,
        bgTop: 326,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 205,
        handContainer18Left: 370,
        handContainer19Left: 538,
        handContainer20Left: 709,
        handContainerTop: 354,
      },
      fi: {
        bgWidth: 163,
        bgHeight: 209,
        bg17Left: 79,
        bg18Left: 249,
        bg19Left: 417,
        bg20Left: 587,
        bgTop: 326,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 208,
        handContainer18Left: 377,
        handContainer19Left: 545,
        handContainer20Left: 714,
        handContainerTop: 354,
      },
      fr: {
        bgWidth: 163,
        bgHeight: 209,
        bg17Left: 79,
        bg18Left: 249,
        bg19Left: 417,
        bg20Left: 587,
        bgTop: 326,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 208,
        handContainer18Left: 377,
        handContainer19Left: 545,
        handContainer20Left: 714,
        handContainerTop: 354,
      },
      ge: {
        bgWidth: 163,
        bgHeight: 209,
        bg17Left: 72,
        bg18Left: 240,
        bg19Left: 412,
        bg20Left: 583,
        bgTop: 326,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 200,
        handContainer18Left: 369,
        handContainer19Left: 540,
        handContainer20Left: 711,
        handContainerTop: 354,
      },
      gr: {
        bgWidth: 163,
        bgHeight: 209,
        bg17Left: 76,
        bg18Left: 245,
        bg19Left: 414,
        bg20Left: 584,
        bgTop: 316,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 204,
        handContainer18Left: 373,
        handContainer19Left: 542,
        handContainer20Left: 711,
        handContainerTop: 354,
      },
      he: {
        bgWidth: 163,
        bgHeight: 209,
        bg17Left: 76,
        bg18Left: 247,
        bg19Left: 414,
        bg20Left: 581,
        bgTop: 326,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 204,
        handContainer18Left: 375,
        handContainer19Left: 543,
        handContainer20Left: 709,
        handContainerTop: 354,
      },
      'hi-IN': {
        bgWidth: 163,
        bgHeight: 209,
        bg17Left: 76,
        bg18Left: 247,
        bg19Left: 414,
        bg20Left: 585,
        bgTop: 326,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 204,
        handContainer18Left: 376,
        handContainer19Left: 541,
        handContainer20Left: 713,
        handContainerTop: 354,
      },
      hu: {
        bgWidth: 163,
        bgHeight: 209,
        bg17Left: 73,
        bg18Left: 241,
        bg19Left: 410,
        bg20Left: 578,
        bgTop: 326,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 201,
        handContainer18Left: 369,
        handContainer19Left: 538,
        handContainer20Left: 706,
        handContainerTop: 354,
      },
      hy: {
        bgWidth: 167,
        bgHeight: 209,
        bg17Left: 70,
        bg18Left: 238,
        bg19Left: 409,
        bg20Left: 581,
        bgTop: 326,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 204,
        handContainer18Left: 371,
        handContainer19Left: 541,
        handContainer20Left: 714,
        handContainerTop: 354,
      },
      id: {
        bgWidth: 163,
        bgHeight: 209,
        bg17Left: 76,
        bg18Left: 247,
        bg19Left: 414,
        bg20Left: 581,
        bgTop: 326,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 204,
        handContainer18Left: 375,
        handContainer19Left: 543,
        handContainer20Left: 709,
        handContainerTop: 354,
      },
      it: {
        bgWidth: 172,
        bgHeight: 209,
        bg17Left: 60,
        bg18Left: 235,
        bg19Left: 413,
        bg20Left: 586,
        bgTop: 330,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 197,
        handContainer18Left: 371,
        handContainer19Left: 545,
        handContainer20Left: 720,
        handContainerTop: 354,
      },
      ja: {
        bgWidth: 163,
        bgHeight: 209,
        bg17Left: 76,
        bg18Left: 251,
        bg19Left: 414,
        bg20Left: 587,
        bgTop: 326,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 204,
        handContainer18Left: 379,
        handContainer19Left: 543,
        handContainer20Left: 714,
        handContainerTop: 354,
      },
      kh: {
        bgWidth: 163,
        bgHeight: 209,
        bg17Left: 73,
        bg18Left: 247,
        bg19Left: 409,
        bg20Left: 577,
        bgTop: 326,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 201,
        handContainer18Left: 376,
        handContainer19Left: 538,
        handContainer20Left: 705,
        handContainerTop: 354,
      },
      ko: {
        bgWidth: 163,
        bgHeight: 209,
        bg17Left: 76,
        bg18Left: 247,
        bg19Left: 414,
        bg20Left: 581,
        bgTop: 326,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 204,
        handContainer18Left: 375,
        handContainer19Left: 543,
        handContainer20Left: 709,
        handContainerTop: 354,
      },
      lt: {
        bgWidth: 163,
        bgHeight: 209,
        bg17Left: 73,
        bg18Left: 242,
        bg19Left: 405,
        bg20Left: 577,
        bgTop: 326,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 201,
        handContainer18Left: 371,
        handContainer19Left: 535,
        handContainer20Left: 705,
        handContainerTop: 354,
      },
      lv: {
        bgWidth: 163,
        bgHeight: 209,
        bg17Left: 71,
        bg18Left: 240,
        bg19Left: 407,
        bg20Left: 578,
        bgTop: 326,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 200,
        handContainer18Left: 368,
        handContainer19Left: 534,
        handContainer20Left: 707,
        handContainerTop: 354,
      },
      mt: {
        bgWidth: 163,
        bgHeight: 209,
        bg17Left: 76,
        bg18Left: 244,
        bg19Left: 414,
        bg20Left: 576,
        bgTop: 326,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 202,
        handContainer18Left: 370,
        handContainer19Left: 542,
        handContainer20Left: 703,
        handContainerTop: 354,
      },
      my: {
        bgWidth: 163,
        bgHeight: 209,
        bg17Left: 72,
        bg18Left: 242,
        bg19Left: 410,
        bg20Left: 577,
        bgTop: 326,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 200,
        handContainer18Left: 370,
        handContainer19Left: 539,
        handContainer20Left: 704,
        handContainerTop: 354,
      },
      nb: {
        bgWidth: 163,
        bgHeight: 209,
        bg17Left: 76,
        bg18Left: 247,
        bg19Left: 414,
        bg20Left: 581,
        bgTop: 326,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 204,
        handContainer18Left: 375,
        handContainer19Left: 543,
        handContainer20Left: 709,
        handContainerTop: 354,
      },
      nl: {
        bgWidth: 163,
        bgHeight: 209,
        bg17Left: 77,
        bg18Left: 248,
        bg19Left: 407,
        bg20Left: 579,
        bgTop: 326,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 205,
        handContainer18Left: 377,
        handContainer19Left: 536,
        handContainer20Left: 707,
        handContainerTop: 354,
      },
      ph: {
        bgWidth: 163,
        bgHeight: 209,
        bg17Left: 69,
        bg18Left: 237,
        bg19Left: 404,
        bg20Left: 573,
        bgTop: 326,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 196,
        handContainer18Left: 366,
        handContainer19Left: 533,
        handContainer20Left: 702,
        handContainerTop: 354,
      },
      pl: {
        bgWidth: 163,
        bgHeight: 209,
        bg17Left: 76,
        bg18Left: 247,
        bg19Left: 414,
        bg20Left: 581,
        bgTop: 326,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 204,
        handContainer18Left: 375,
        handContainer19Left: 543,
        handContainer20Left: 709,
        handContainerTop: 354,
      },
      'pt-BR': {
        bgWidth: 163,
        bgHeight: 209,
        bg17Left: 76,
        bg18Left: 247,
        bg19Left: 414,
        bg20Left: 581,
        bgTop: 326,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 204,
        handContainer18Left: 375,
        handContainer19Left: 543,
        handContainer20Left: 709,
        handContainerTop: 354,
      },
      ro: {
        bgWidth: 163,
        bgHeight: 209,
        bg17Left: 76,
        bg18Left: 247,
        bg19Left: 414,
        bg20Left: 581,
        bgTop: 326,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 204,
        handContainer18Left: 375,
        handContainer19Left: 543,
        handContainer20Left: 709,
        handContainerTop: 354,
      },
      ru: {
        bgWidth: 163,
        bgHeight: 200,
        bg17Left: 76,
        bg18Left: 247,
        bg19Left: 414,
        bg20Left: 581,
        bgTop: 335,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 205,
        handContainer18Left: 374,
        handContainer19Left: 542,
        handContainer20Left: 709,
        handContainerTop: 354,
      },
      si: {
        bgWidth: 163,
        bgHeight: 209,
        bg17Left: 76,
        bg18Left: 243,
        bg19Left: 411,
        bg20Left: 579,
        bgTop: 326,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 205,
        handContainer18Left: 372,
        handContainer19Left: 540,
        handContainer20Left: 707,
        handContainerTop: 354,
      },
      sk: {
        bgWidth: 163,
        bgHeight: 209,
        bg17Left: 76,
        bg18Left: 247,
        bg19Left: 414,
        bg20Left: 581,
        bgTop: 326,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 204,
        handContainer18Left: 375,
        handContainer19Left: 543,
        handContainer20Left: 709,
        handContainerTop: 354,
      },
      'sr-RS': {
        bgWidth: 163,
        bgHeight: 209,
        bg17Left: 76,
        bg18Left: 247,
        bg19Left: 414,
        bg20Left: 581,
        bgTop: 326,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 204,
        handContainer18Left: 375,
        handContainer19Left: 543,
        handContainer20Left: 709,
        handContainerTop: 354,
      },
      sv: {
        bgWidth: 163,
        bgHeight: 209,
        bg17Left: 76,
        bg18Left: 247,
        bg19Left: 414,
        bg20Left: 581,
        bgTop: 326,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 204,
        handContainer18Left: 375,
        handContainer19Left: 543,
        handContainer20Left: 709,
        handContainerTop: 354,
      },
      'ta-IN': {
        bgWidth: 174,
        bgHeight: 196,
        bg17Left: 61,
        bg18Left: 247,
        bg19Left: 416,
        bg20Left: 588,
        bgTop: 336,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 204,
        handContainer18Left: 375,
        handContainer19Left: 543,
        handContainer20Left: 717,
        handContainerTop: 360,
      },
      th: {
        bgWidth: 163,
        bgHeight: 209,
        bg17Left: 76,
        bg18Left: 241,
        bg19Left: 401,
        bg20Left: 574,
        bgTop: 326,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 203,
        handContainer18Left: 370,
        handContainer19Left: 529,
        handContainer20Left: 702,
        handContainerTop: 354,
      },
      tr: {
        bgWidth: 163,
        bgHeight: 209,
        bg17Left: 69,
        bg18Left: 240,
        bg19Left: 409,
        bg20Left: 581,
        bgTop: 326,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 197,
        handContainer18Left: 368,
        handContainer19Left: 536,
        handContainer20Left: 708,
        handContainerTop: 354,
      },
      ua: {
        bgWidth: 163,
        bgHeight: 200,
        bg17Left: 76,
        bg18Left: 247,
        bg19Left: 414,
        bg20Left: 581,
        bgTop: 335,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 205,
        handContainer18Left: 374,
        handContainer19Left: 542,
        handContainer20Left: 709,
        handContainerTop: 354,
      },
      vi: {
        bgWidth: 165,
        bgHeight: 209,
        bg17Left: 64,
        bg18Left: 242,
        bg19Left: 415,
        bg20Left: 590,
        bgTop: 326,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 197,
        handContainer18Left: 372,
        handContainer19Left: 543,
        handContainer20Left: 720,
        handContainerTop: 354,
      },
      'zh-Hans': {
        bgWidth: 163,
        bgHeight: 209,
        bg17Left: 76,
        bg18Left: 247,
        bg19Left: 414,
        bg20Left: 581,
        bgTop: 326,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 204,
        handContainer18Left: 375,
        handContainer19Left: 543,
        handContainer20Left: 709,
        handContainerTop: 354,
      },
      'zh-Hant': {
        bgWidth: 163,
        bgHeight: 209,
        bg17Left: 76,
        bg18Left: 247,
        bg19Left: 414,
        bg20Left: 581,
        bgTop: 326,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 204,
        handContainer18Left: 375,
        handContainer19Left: 543,
        handContainer20Left: 709,
        handContainerTop: 354,
      },
    };
  }
}
